
export type BrandKey = "test"
| "jottacloud"
| "elkjop"
| "elgiganten"
| "gigantti"
| "elko"
| "mediamarkt"
| "saturn"
| "tele2"
| "teliasky"
| "teliacloud"
| "tsky"
| "onlime"
| "obos"
| "halebop"
| "phonero"
| "letsgo"

export type ColorKey = "background__critical_danger"
| "background__critical_warning"
| "background__danger"
| "background__good"
| "background__grey_1"
| "background__grey_2"
| "background__grey_3"
| "background__grey_4"
| "background__grey_5"
| "background__grey_6"
| "background__informative"
| "background__primary"
| "background__warning"
| "black_and_white__always_black"
| "black_and_white__always_white"
| "black_and_white__auto_black_to_white"
| "black_and_white__auto_grey_to_black"
| "black_and_white__auto_white_to_black"
| "border__base"
| "border__in_focus"
| "border__light_base"
| "border__lightest_base"
| "elements__alert"
| "elements__context_menu"
| "elements__control_element"
| "elements__divider"
| "elements__file_and_folder_icons__file_background"
| "elements__file_and_folder_icons__file_foreground"
| "elements__file_and_folder_icons__folder_background"
| "elements__file_and_folder_icons__folder_background_active"
| "elements__folder_icons"
| "elements__logo"
| "elements__modal_branded"
| "elements__modal_unbranded"
| "email__heading"
| "foreground__danger"
| "foreground__good"
| "foreground__grey_1"
| "foreground__grey_2"
| "foreground__grey_3"
| "foreground__grey_4"
| "foreground__informative"
| "foreground__primary"
| "foreground__warning"
| "interactive_content__badge__1"
| "interactive_content__badge__2"
| "interactive_content__badge__3"
| "interactive_content__badge__4"
| "interactive_content__badge__5"
| "interactive_content__badge__6"
| "interactive_content__badge__7"
| "interactive_content__badge__outline"
| "interactive_content__badge__text"
| "interactive_content__buttons__black_to_white__fill_default"
| "interactive_content__buttons__black_to_white__fill_hover"
| "interactive_content__buttons__black_to_white__fill_pressed"
| "interactive_content__buttons__black_to_white__outline_default"
| "interactive_content__buttons__black_to_white__outline_hover"
| "interactive_content__buttons__black_to_white__outline_pressed"
| "interactive_content__buttons__black_to_white__text_default"
| "interactive_content__buttons__black_to_white__text_hover"
| "interactive_content__buttons__black_to_white__text_pressed"
| "interactive_content__buttons__destructive__fill_default"
| "interactive_content__buttons__destructive__fill_hover"
| "interactive_content__buttons__destructive__fill_pressed"
| "interactive_content__buttons__destructive__outline_default"
| "interactive_content__buttons__destructive__outline_hover"
| "interactive_content__buttons__destructive__outline_pressed"
| "interactive_content__buttons__destructive__text_default"
| "interactive_content__buttons__destructive__text_hover"
| "interactive_content__buttons__destructive__text_pressed"
| "interactive_content__buttons__ghost__fill_default"
| "interactive_content__buttons__ghost__fill_hover"
| "interactive_content__buttons__ghost__fill_pressed"
| "interactive_content__buttons__ghost__outline_default"
| "interactive_content__buttons__ghost__outline_hover"
| "interactive_content__buttons__ghost__outline_pressed"
| "interactive_content__buttons__ghost__text_default"
| "interactive_content__buttons__ghost__text_hover"
| "interactive_content__buttons__ghost__text_pressed"
| "interactive_content__buttons__outline__fill_default"
| "interactive_content__buttons__outline__fill_hover"
| "interactive_content__buttons__outline__fill_pressed"
| "interactive_content__buttons__outline__outline_default"
| "interactive_content__buttons__outline__outline_hover"
| "interactive_content__buttons__outline__outline_pressed"
| "interactive_content__buttons__outline__text_default"
| "interactive_content__buttons__outline__text_hover"
| "interactive_content__buttons__outline__text_pressed"
| "interactive_content__buttons__primary__fill_default"
| "interactive_content__buttons__primary__fill_hover"
| "interactive_content__buttons__primary__fill_pressed"
| "interactive_content__buttons__primary__outline_default"
| "interactive_content__buttons__primary__outline_hover"
| "interactive_content__buttons__primary__outline_pressed"
| "interactive_content__buttons__primary__text_default"
| "interactive_content__buttons__primary__text_hover"
| "interactive_content__buttons__primary__text_pressed"
| "interactive_content__edit_mode__background"
| "interactive_content__edit_mode__foreground"
| "interactive_content__lists__surface_on_hover"
| "interactive_content__lists__surface_on_hover_branded"
| "interactive_content__lists__surface_while_active"
| "interactive_content__lists__surface_while_active_branded"
| "interactive_content__text_link__default"
| "interactive_content__tooltips__background"
| "interactive_content__tooltips__foreground"
| "interactive_content__tooltips__icon"
| "unbranded_colors__blue"
| "unbranded_colors__green"
| "unbranded_colors__purple"
| "unbranded_colors__red"
| "unbranded_colors__yellow"
| "web__authentication__background"
| "web__authentication__header_foreground"
| "web__header__background"
| "web__header__foreground"
| "web__navigation__background"
| "web__navigation__divider"
| "web__navigation__foreground_default"
| "web__navigation__foreground_hover"
| "web__navigation__foreground_pressed"
| "web__upgrade__background"
| "web__upgrade__recommended"
| "web__upgrade__tab_selection_line"
| "web__upgrade__tag"
| "web__upgrade__text_highlight"
| "website__paid_signup_custom__background_left"
| "website__paid_signup_custom__background_logo_icon"
| "website__paid_signup_custom__background_right"
| "website__paid_signup_custom__divider"
| "website__paid_signup_custom__link"
| "website__paid_signup_custom__password_box"
| "website__paid_signup_custom__radio_button"
| "website__paid_signup_custom__radio_button_background"
| "website__paid_signup_custom__radio_button_background_hover"
| "website__paid_signup_custom__radio_button_stroke_hover"
| "website__paid_signup_custom__strong_password"
| "website__paid_signup_custom__subtext_summary"

export type TypographyKey = "body__3xlarge_long__fontweight"
| "body__3xlarge_long__lineheight"
| "body__3xlarge_long__fontsize"
| "body__2xlarge_long__fontweight"
| "body__2xlarge_long__lineheight"
| "body__2xlarge_long__fontsize"
| "body__xlarge_long__fontweight"
| "body__xlarge_long__lineheight"
| "body__xlarge_long__fontsize"
| "body__large_long__fontweight"
| "body__large_long__lineheight"
| "body__large_long__fontsize"
| "body__large_short__fontweight"
| "body__large_short__lineheight"
| "body__large_short__fontsize"
| "body__medium_long__fontweight"
| "body__medium_long__lineheight"
| "body__medium_long__fontsize"
| "body__medium_short__fontweight"
| "body__medium_short__lineheight"
| "body__medium_short__fontsize"
| "body__small_long__fontweight"
| "body__small_long__lineheight"
| "body__small_long__fontsize"
| "body__small_short__fontweight"
| "body__small_short__lineheight"
| "body__small_short__fontsize"
| "display__d1__fontweight"
| "display__d1__lineheight"
| "display__d1__fontsize"
| "display__d2__fontweight"
| "display__d2__lineheight"
| "display__d2__fontsize"
| "display__d1_black__fontweight"
| "display__d1_black__lineheight"
| "display__d1_black__fontsize"
| "display__d2_black__fontweight"
| "display__d2_black__lineheight"
| "display__d2_black__fontsize"
| "label__large__fontweight"
| "label__large__lineheight"
| "label__large__fontsize"
| "label__medium__fontweight"
| "label__medium__lineheight"
| "label__medium__fontsize"
| "label__medium_fat__fontweight"
| "label__medium_fat__lineheight"
| "label__medium_fat__fontsize"
| "label__small__fontweight"
| "label__small__lineheight"
| "label__small__fontsize"
| "heading__h1__fontweight"
| "heading__h1__lineheight"
| "heading__h1__fontsize"
| "heading__h2__fontweight"
| "heading__h2__lineheight"
| "heading__h2__fontsize"
| "heading__h3__fontweight"
| "heading__h3__lineheight"
| "heading__h3__fontsize"
| "heading__h4__fontweight"
| "heading__h4__lineheight"
| "heading__h4__fontsize"
| "link__medium__fontweight"
| "link__medium__lineheight"
| "link__medium__fontsize"
| "link__small__fontweight"
| "link__small__lineheight"
| "link__small__fontsize"
| "link__medium_long__fontweight"
| "link__medium_long__lineheight"
| "link__medium_long__fontsize"
| "link__small_long__fontweight"
| "link__small_long__lineheight"
| "link__small_long__fontsize"
| "title__large__fontweight"
| "title__large__lineheight"
| "title__large__fontsize"
| "title__large_bold__fontweight"
| "title__large_bold__lineheight"
| "title__large_bold__fontsize"
| "title__medium__fontweight"
| "title__medium__lineheight"
| "title__medium__fontsize"
| "title__medium_bold__fontweight"
| "title__medium_bold__lineheight"
| "title__medium_bold__fontsize"
| "title__small__fontweight"
| "title__small__lineheight"
| "title__small__fontsize"
| "title__small_bold__fontweight"
| "title__small_bold__lineheight"
| "title__small_bold__fontsize"
| "title__xlarge__fontweight"
| "title__xlarge__lineheight"
| "title__xlarge__fontsize"
| "title__xlarge_bold__fontweight"
| "title__xlarge_bold__lineheight"
| "title__xlarge_bold__fontsize"

type Color = string
type Colors = {
    [key in ColorKey]: Color
}

export interface Brand {
    colors: Colors
}

export interface System {
    typography: Record<TypographyKey, number>
    brands: Record<BrandKey, Brand>
}

export const designSystem: System = {
  "typography": {
    "body__3xlarge_long__fontweight": 400,
    "body__3xlarge_long__lineheight": 52,
    "body__3xlarge_long__fontsize": 40,
    "body__2xlarge_long__fontweight": 400,
    "body__2xlarge_long__lineheight": 48,
    "body__2xlarge_long__fontsize": 32,
    "body__xlarge_long__fontweight": 400,
    "body__xlarge_long__lineheight": 32,
    "body__xlarge_long__fontsize": 24,
    "body__large_long__fontweight": 400,
    "body__large_long__lineheight": 28,
    "body__large_long__fontsize": 20,
    "body__large_short__fontweight": 400,
    "body__large_short__lineheight": 20,
    "body__large_short__fontsize": 20,
    "body__medium_long__fontweight": 400,
    "body__medium_long__lineheight": 24,
    "body__medium_long__fontsize": 16,
    "body__medium_short__fontweight": 400,
    "body__medium_short__lineheight": 16,
    "body__medium_short__fontsize": 16,
    "body__small_long__fontweight": 400,
    "body__small_long__lineheight": 24,
    "body__small_long__fontsize": 14,
    "body__small_short__fontweight": 400,
    "body__small_short__lineheight": 16,
    "body__small_short__fontsize": 14,
    "display__d1__fontweight": 400,
    "display__d1__lineheight": 72,
    "display__d1__fontsize": 64,
    "display__d2__fontweight": 400,
    "display__d2__lineheight": 52,
    "display__d2__fontsize": 48,
    "display__d1_black__fontweight": 900,
    "display__d1_black__lineheight": 72,
    "display__d1_black__fontsize": 64,
    "display__d2_black__fontweight": 900,
    "display__d2_black__lineheight": 52,
    "display__d2_black__fontsize": 48,
    "label__large__fontweight": 600,
    "label__large__lineheight": 20,
    "label__large__fontsize": 20,
    "label__medium__fontweight": 600,
    "label__medium__lineheight": 16,
    "label__medium__fontsize": 16,
    "label__medium_fat__fontweight": 900,
    "label__medium_fat__lineheight": 16,
    "label__medium_fat__fontsize": 16,
    "label__small__fontweight": 600,
    "label__small__lineheight": 16,
    "label__small__fontsize": 14,
    "heading__h1__fontweight": 700,
    "heading__h1__lineheight": 32,
    "heading__h1__fontsize": 24,
    "heading__h2__fontweight": 700,
    "heading__h2__lineheight": 28,
    "heading__h2__fontsize": 20,
    "heading__h3__fontweight": 700,
    "heading__h3__lineheight": 24,
    "heading__h3__fontsize": 16,
    "heading__h4__fontweight": 700,
    "heading__h4__lineheight": 24,
    "heading__h4__fontsize": 14,
    "link__medium__fontweight": 400,
    "link__medium__lineheight": 16,
    "link__medium__fontsize": 16,
    "link__small__fontweight": 400,
    "link__small__lineheight": 16,
    "link__small__fontsize": 14,
    "link__medium_long__fontweight": 400,
    "link__medium_long__lineheight": 24,
    "link__medium_long__fontsize": 16,
    "link__small_long__fontweight": 400,
    "link__small_long__lineheight": 24,
    "link__small_long__fontsize": 14,
    "title__large__fontweight": 400,
    "title__large__lineheight": 32,
    "title__large__fontsize": 32,
    "title__large_bold__fontweight": 700,
    "title__large_bold__lineheight": 32,
    "title__large_bold__fontsize": 32,
    "title__medium__fontweight": 400,
    "title__medium__lineheight": 28,
    "title__medium__fontsize": 28,
    "title__medium_bold__fontweight": 700,
    "title__medium_bold__lineheight": 28,
    "title__medium_bold__fontsize": 28,
    "title__small__fontweight": 400,
    "title__small__lineheight": 24,
    "title__small__fontsize": 24,
    "title__small_bold__fontweight": 700,
    "title__small_bold__lineheight": 24,
    "title__small_bold__fontsize": 24,
    "title__xlarge__fontweight": 400,
    "title__xlarge__lineheight": 40,
    "title__xlarge__fontsize": 40,
    "title__xlarge_bold__fontweight": 700,
    "title__xlarge_bold__lineheight": 40,
    "title__xlarge_bold__fontsize": 40
  },
  "brands": {
    "test": {
      "colors": {
        "background__critical_danger": "#ef3138",
        "background__critical_warning": "#e4b91e",
        "background__danger": "#fde5e6",
        "background__good": "#d4f7f0",
        "background__grey_1": "#f9fafa",
        "background__grey_2": "#f5f6f7",
        "background__grey_3": "#f1f2f2",
        "background__grey_4": "#ededed",
        "background__grey_5": "#e8e8e8",
        "background__grey_6": "#e3e3e3",
        "background__informative": "#ebf2ff",
        "background__primary": "#ffffff",
        "background__warning": "#faf4d9",
        "black_and_white__always_black": "#000000",
        "black_and_white__always_white": "#ffffff",
        "black_and_white__auto_black_to_white": "#000000",
        "black_and_white__auto_grey_to_black": "#f1f2f2",
        "black_and_white__auto_white_to_black": "#ffffff",
        "border__base": "#a7acb1",
        "border__in_focus": "#085398",
        "border__light_base": "#d9dcdf",
        "border__lightest_base": "#ededed",
        "elements__alert": "#f1f2f2",
        "elements__context_menu": "#ffffff",
        "elements__control_element": "#0b76d9",
        "elements__divider": "#a7acb1",
        "elements__file_and_folder_icons__file_background": "#f1f2f2",
        "elements__file_and_folder_icons__file_foreground": "#2d2f32",
        "elements__file_and_folder_icons__folder_background": "#ffffff",
        "elements__file_and_folder_icons__folder_background_active": "#ebf2ff",
        "elements__folder_icons": "#0b76d9",
        "elements__logo": "#000000",
        "elements__modal_branded": "#ffffff",
        "elements__modal_unbranded": "#ffffff",
        "email__heading": "#282f33",
        "foreground__danger": "#ef3138",
        "foreground__good": "#00685e",
        "foreground__grey_1": "#3d3e40",
        "foreground__grey_2": "#4a4d50",
        "foreground__grey_3": "#5c6166",
        "foreground__grey_4": "#6f757b",
        "foreground__informative": "#085398",
        "foreground__primary": "#2d2f32",
        "foreground__warning": "#e4b91e",
        "interactive_content__badge__1": "#000000",
        "interactive_content__badge__2": "#4a4d50",
        "interactive_content__badge__3": "#2d2f32",
        "interactive_content__badge__4": "#898989",
        "interactive_content__badge__5": "#414141",
        "interactive_content__badge__6": "#151515",
        "interactive_content__badge__7": "#000000",
        "interactive_content__badge__outline": "#ffffff",
        "interactive_content__badge__text": "#ffffff",
        "interactive_content__buttons__black_to_white__fill_default": "#000000",
        "interactive_content__buttons__black_to_white__fill_hover": "#3d3e40",
        "interactive_content__buttons__black_to_white__fill_pressed": "#2d2f32",
        "interactive_content__buttons__black_to_white__outline_default": "#000000",
        "interactive_content__buttons__black_to_white__outline_hover": "#3d3e40",
        "interactive_content__buttons__black_to_white__outline_pressed": "#2d2f32",
        "interactive_content__buttons__black_to_white__text_default": "#f5f6f7",
        "interactive_content__buttons__black_to_white__text_hover": "#ffffff",
        "interactive_content__buttons__black_to_white__text_pressed": "#ffffff",
        "interactive_content__buttons__destructive__fill_default": "#fde5e6",
        "interactive_content__buttons__destructive__fill_hover": "#fde5e6",
        "interactive_content__buttons__destructive__fill_pressed": "#fbcbcd",
        "interactive_content__buttons__destructive__outline_default": "#fde5e6",
        "interactive_content__buttons__destructive__outline_hover": "#f46f74",
        "interactive_content__buttons__destructive__outline_pressed": "#fbcbcd",
        "interactive_content__buttons__destructive__text_default": "#c72127",
        "interactive_content__buttons__destructive__text_hover": "#c72127",
        "interactive_content__buttons__destructive__text_pressed": "#c72127",
        "interactive_content__buttons__ghost__fill_default": "#00000000",
        "interactive_content__buttons__ghost__fill_hover": "#d9dcdf",
        "interactive_content__buttons__ghost__fill_pressed": "#c3c8cd",
        "interactive_content__buttons__ghost__outline_default": "#00000000",
        "interactive_content__buttons__ghost__outline_hover": "#d9dcdf",
        "interactive_content__buttons__ghost__outline_pressed": "#c3c8cd",
        "interactive_content__buttons__ghost__text_default": "#2d2f32",
        "interactive_content__buttons__ghost__text_hover": "#000000",
        "interactive_content__buttons__ghost__text_pressed": "#2d2f32",
        "interactive_content__buttons__outline__fill_default": "#00000000",
        "interactive_content__buttons__outline__fill_hover": "#f5f6f7",
        "interactive_content__buttons__outline__fill_pressed": "#f5f6f7",
        "interactive_content__buttons__outline__outline_default": "#92989f",
        "interactive_content__buttons__outline__outline_hover": "#6f757b",
        "interactive_content__buttons__outline__outline_pressed": "#a7acb1",
        "interactive_content__buttons__outline__text_default": "#2d2f32",
        "interactive_content__buttons__outline__text_hover": "#000000",
        "interactive_content__buttons__outline__text_pressed": "#000000",
        "interactive_content__buttons__primary__fill_default": "#000000",
        "interactive_content__buttons__primary__fill_hover": "#4a4d50",
        "interactive_content__buttons__primary__fill_pressed": "#2d2f32",
        "interactive_content__buttons__primary__outline_default": "#000000",
        "interactive_content__buttons__primary__outline_hover": "#4a4d50",
        "interactive_content__buttons__primary__outline_pressed": "#2d2f32",
        "interactive_content__buttons__primary__text_default": "#ffffff",
        "interactive_content__buttons__primary__text_hover": "#ffffff",
        "interactive_content__buttons__primary__text_pressed": "#ffffff",
        "interactive_content__edit_mode__background": "#2d2f32",
        "interactive_content__edit_mode__foreground": "#ffffff",
        "interactive_content__lists__surface_on_hover": "#f1f2f2",
        "interactive_content__lists__surface_on_hover_branded": "#f1f2f2",
        "interactive_content__lists__surface_while_active": "#ebf2ff",
        "interactive_content__lists__surface_while_active_branded": "#ebf2ff",
        "interactive_content__text_link__default": "#085398",
        "interactive_content__tooltips__background": "#000000",
        "interactive_content__tooltips__foreground": "#ffffff",
        "interactive_content__tooltips__icon": "#f5f6f7",
        "unbranded_colors__blue": "#46a8ef",
        "unbranded_colors__green": "#329086",
        "unbranded_colors__purple": "#df57d9",
        "unbranded_colors__red": "#f46f74",
        "unbranded_colors__yellow": "#edd26f",
        "web__authentication__background": "#f9fafa",
        "web__authentication__header_foreground": "#2d2f32",
        "web__header__background": "#ffffff00",
        "web__header__foreground": "#2d2f32",
        "web__navigation__background": "#f9fafa",
        "web__navigation__divider": "#d9dcdf",
        "web__navigation__foreground_default": "#6f757b",
        "web__navigation__foreground_hover": "#000000",
        "web__navigation__foreground_pressed": "#000000",
        "web__upgrade__background": "#f9fafa",
        "web__upgrade__recommended": "#2d2f32",
        "web__upgrade__tab_selection_line": "#2d2f32",
        "web__upgrade__tag": "#f5f6f7",
        "web__upgrade__text_highlight": "#2d2f32",
        "website__paid_signup_custom__background_left": "#ffffff",
        "website__paid_signup_custom__background_logo_icon": "#ffffff",
        "website__paid_signup_custom__background_right": "#f5f6f7",
        "website__paid_signup_custom__divider": "#d9dcdf",
        "website__paid_signup_custom__link": "#085398",
        "website__paid_signup_custom__password_box": "#f1f2f2",
        "website__paid_signup_custom__radio_button": "#0b76d9",
        "website__paid_signup_custom__radio_button_background": "#ebf2ff",
        "website__paid_signup_custom__radio_button_background_hover": "#0b76d9",
        "website__paid_signup_custom__radio_button_stroke_hover": "#0b76d9",
        "website__paid_signup_custom__strong_password": "#5eb2aa",
        "website__paid_signup_custom__subtext_summary": "#5c6166"
      }
    },
    "jottacloud": {
      "colors": {
        "background__critical_danger": "#ef3138",
        "background__critical_warning": "#e4b91e",
        "background__danger": "#fde5e6",
        "background__good": "#d4f7f0",
        "background__grey_1": "#f9fafa",
        "background__grey_2": "#f5f6f7",
        "background__grey_3": "#f1f2f2",
        "background__grey_4": "#ededed",
        "background__grey_5": "#e8e8e8",
        "background__grey_6": "#e3e3e3",
        "background__informative": "#ebf2ff",
        "background__primary": "#ffffff",
        "background__warning": "#faf4d9",
        "black_and_white__always_black": "#000000",
        "black_and_white__always_white": "#ffffff",
        "black_and_white__auto_black_to_white": "#000000",
        "black_and_white__auto_grey_to_black": "#f1f2f2",
        "black_and_white__auto_white_to_black": "#ffffff",
        "border__base": "#a7acb1",
        "border__in_focus": "#085398",
        "border__light_base": "#d9dcdf",
        "border__lightest_base": "#ededed",
        "elements__alert": "#7d5fe6",
        "elements__context_menu": "#ffffff",
        "elements__control_element": "#0b76d9",
        "elements__divider": "#a7acb1",
        "elements__file_and_folder_icons__file_background": "#f1f2f2",
        "elements__file_and_folder_icons__file_foreground": "#2d2f32",
        "elements__file_and_folder_icons__folder_background": "#ffffff",
        "elements__file_and_folder_icons__folder_background_active": "#ebf2ff",
        "elements__folder_icons": "#744ff6",
        "elements__logo": "#7d5fe6",
        "elements__modal_branded": "#ffffff",
        "elements__modal_unbranded": "#ffffff",
        "email__heading": "#282f33",
        "foreground__danger": "#ef3138",
        "foreground__good": "#00685e",
        "foreground__grey_1": "#3d3e40",
        "foreground__grey_2": "#4a4d50",
        "foreground__grey_3": "#5c6166",
        "foreground__grey_4": "#6f757b",
        "foreground__informative": "#085398",
        "foreground__primary": "#2d2f32",
        "foreground__warning": "#e4b91e",
        "interactive_content__badge__1": "#6173e8",
        "interactive_content__badge__2": "#7e4f6f",
        "interactive_content__badge__3": "#9c61e8",
        "interactive_content__badge__4": "#c38cec",
        "interactive_content__badge__5": "#e56399",
        "interactive_content__badge__6": "#f055be",
        "interactive_content__badge__7": "#ff79ff",
        "interactive_content__badge__outline": "#ffffff",
        "interactive_content__badge__text": "#ffffff",
        "interactive_content__buttons__black_to_white__fill_default": "#000000",
        "interactive_content__buttons__black_to_white__fill_hover": "#3d3e40",
        "interactive_content__buttons__black_to_white__fill_pressed": "#2d2f32",
        "interactive_content__buttons__black_to_white__outline_default": "#000000",
        "interactive_content__buttons__black_to_white__outline_hover": "#3d3e40",
        "interactive_content__buttons__black_to_white__outline_pressed": "#2d2f32",
        "interactive_content__buttons__black_to_white__text_default": "#f5f6f7",
        "interactive_content__buttons__black_to_white__text_hover": "#ffffff",
        "interactive_content__buttons__black_to_white__text_pressed": "#ffffff",
        "interactive_content__buttons__destructive__fill_default": "#fde5e6",
        "interactive_content__buttons__destructive__fill_hover": "#fde5e6",
        "interactive_content__buttons__destructive__fill_pressed": "#fbcbcd",
        "interactive_content__buttons__destructive__outline_default": "#fde5e6",
        "interactive_content__buttons__destructive__outline_hover": "#f46f74",
        "interactive_content__buttons__destructive__outline_pressed": "#fbcbcd",
        "interactive_content__buttons__destructive__text_default": "#c72127",
        "interactive_content__buttons__destructive__text_hover": "#c72127",
        "interactive_content__buttons__destructive__text_pressed": "#c72127",
        "interactive_content__buttons__ghost__fill_default": "#00000000",
        "interactive_content__buttons__ghost__fill_hover": "#d9dcdf",
        "interactive_content__buttons__ghost__fill_pressed": "#c3c8cd",
        "interactive_content__buttons__ghost__outline_default": "#00000000",
        "interactive_content__buttons__ghost__outline_hover": "#d9dcdf",
        "interactive_content__buttons__ghost__outline_pressed": "#c3c8cd",
        "interactive_content__buttons__ghost__text_default": "#2d2f32",
        "interactive_content__buttons__ghost__text_hover": "#000000",
        "interactive_content__buttons__ghost__text_pressed": "#2d2f32",
        "interactive_content__buttons__outline__fill_default": "#00000000",
        "interactive_content__buttons__outline__fill_hover": "#f5f6f7",
        "interactive_content__buttons__outline__fill_pressed": "#f5f6f7",
        "interactive_content__buttons__outline__outline_default": "#92989f",
        "interactive_content__buttons__outline__outline_hover": "#6f757b",
        "interactive_content__buttons__outline__outline_pressed": "#a7acb1",
        "interactive_content__buttons__outline__text_default": "#2d2f32",
        "interactive_content__buttons__outline__text_hover": "#000000",
        "interactive_content__buttons__outline__text_pressed": "#000000",
        "interactive_content__buttons__primary__fill_default": "#744ff6",
        "interactive_content__buttons__primary__fill_hover": "#6a45eb",
        "interactive_content__buttons__primary__fill_pressed": "#603be1",
        "interactive_content__buttons__primary__outline_default": "#7d5fe6",
        "interactive_content__buttons__primary__outline_hover": "#6a45eb",
        "interactive_content__buttons__primary__outline_pressed": "#603be1",
        "interactive_content__buttons__primary__text_default": "#ffffff",
        "interactive_content__buttons__primary__text_hover": "#ffffff",
        "interactive_content__buttons__primary__text_pressed": "#ffffff",
        "interactive_content__edit_mode__background": "#7d5fe6",
        "interactive_content__edit_mode__foreground": "#ffffff",
        "interactive_content__lists__surface_on_hover": "#f1f2f2",
        "interactive_content__lists__surface_on_hover_branded": "#f1f2f2",
        "interactive_content__lists__surface_while_active": "#ebf2ff",
        "interactive_content__lists__surface_while_active_branded": "#ebf2ff",
        "interactive_content__text_link__default": "#085398",
        "interactive_content__tooltips__background": "#000000",
        "interactive_content__tooltips__foreground": "#ffffff",
        "interactive_content__tooltips__icon": "#f5f6f7",
        "unbranded_colors__blue": "#46a8ef",
        "unbranded_colors__green": "#329086",
        "unbranded_colors__purple": "#df57d9",
        "unbranded_colors__red": "#f46f74",
        "unbranded_colors__yellow": "#edd26f",
        "web__authentication__background": "#f3f2f8",
        "web__authentication__header_foreground": "#2d2f32",
        "web__header__background": "#00000000",
        "web__header__foreground": "#2d2f32",
        "web__navigation__background": "#f9fafa",
        "web__navigation__divider": "#d9dcdf",
        "web__navigation__foreground_default": "#6f757b",
        "web__navigation__foreground_hover": "#744ff6",
        "web__navigation__foreground_pressed": "#744ff6",
        "web__upgrade__background": "#f3f2f8",
        "web__upgrade__recommended": "#292244",
        "web__upgrade__tab_selection_line": "#2d2f32",
        "web__upgrade__tag": "#f3f2f8",
        "web__upgrade__text_highlight": "#744ff6",
        "website__paid_signup_custom__background_left": "#ffffff",
        "website__paid_signup_custom__background_logo_icon": "#f3f2f8",
        "website__paid_signup_custom__background_right": "#f3f2f8",
        "website__paid_signup_custom__divider": "#cabbfb",
        "website__paid_signup_custom__link": "#c86a28",
        "website__paid_signup_custom__password_box": "#f0f2ee",
        "website__paid_signup_custom__radio_button": "#7d5fe6",
        "website__paid_signup_custom__radio_button_background": "#f3f2f8",
        "website__paid_signup_custom__radio_button_background_hover": "#ffffff",
        "website__paid_signup_custom__radio_button_stroke_hover": "#6f757b",
        "website__paid_signup_custom__strong_password": "#5eb2aa",
        "website__paid_signup_custom__subtext_summary": "#1f183a"
      }
    },
    "elkjop": {
      "colors": {
        "background__critical_danger": "#ef3138",
        "background__critical_warning": "#e4b91e",
        "background__danger": "#fde5e6",
        "background__good": "#d4f7f0",
        "background__grey_1": "#f9fafa",
        "background__grey_2": "#f5f6f7",
        "background__grey_3": "#f1f2f2",
        "background__grey_4": "#ededed",
        "background__grey_5": "#e8e8e8",
        "background__grey_6": "#e3e3e3",
        "background__informative": "#ebf2ff",
        "background__primary": "#ffffff",
        "background__warning": "#faf4d9",
        "black_and_white__always_black": "#000000",
        "black_and_white__always_white": "#ffffff",
        "black_and_white__auto_black_to_white": "#000000",
        "black_and_white__auto_grey_to_black": "#f1f2f2",
        "black_and_white__auto_white_to_black": "#ffffff",
        "border__base": "#a7acb1",
        "border__in_focus": "#085398",
        "border__light_base": "#d9dcdf",
        "border__lightest_base": "#ededed",
        "elements__alert": "#041752",
        "elements__context_menu": "#ffffff",
        "elements__control_element": "#0b76d9",
        "elements__divider": "#a7acb1",
        "elements__file_and_folder_icons__file_background": "#f1f2f2",
        "elements__file_and_folder_icons__file_foreground": "#2d2f32",
        "elements__file_and_folder_icons__folder_background": "#ffffff",
        "elements__file_and_folder_icons__folder_background_active": "#ebf2ff",
        "elements__folder_icons": "#041752",
        "elements__logo": "#78bf26",
        "elements__modal_branded": "#ffffff",
        "elements__modal_unbranded": "#ffffff",
        "email__heading": "#242424",
        "foreground__danger": "#ef3138",
        "foreground__good": "#00685e",
        "foreground__grey_1": "#3d3e40",
        "foreground__grey_2": "#4a4d50",
        "foreground__grey_3": "#5c6166",
        "foreground__grey_4": "#6f757b",
        "foreground__informative": "#085398",
        "foreground__primary": "#2d2f32",
        "foreground__warning": "#e4b91e",
        "interactive_content__badge__1": "#020327",
        "interactive_content__badge__2": "#024206",
        "interactive_content__badge__3": "#080942",
        "interactive_content__badge__4": "#136319",
        "interactive_content__badge__5": "#262875",
        "interactive_content__badge__6": "#2d8234",
        "interactive_content__badge__7": "#3d3f8b",
        "interactive_content__badge__outline": "#ffffff",
        "interactive_content__badge__text": "#ffffff",
        "interactive_content__buttons__black_to_white__fill_default": "#000000",
        "interactive_content__buttons__black_to_white__fill_hover": "#3d3e40",
        "interactive_content__buttons__black_to_white__fill_pressed": "#2d2f32",
        "interactive_content__buttons__black_to_white__outline_default": "#000000",
        "interactive_content__buttons__black_to_white__outline_hover": "#3d3e40",
        "interactive_content__buttons__black_to_white__outline_pressed": "#2d2f32",
        "interactive_content__buttons__black_to_white__text_default": "#f5f6f7",
        "interactive_content__buttons__black_to_white__text_hover": "#ffffff",
        "interactive_content__buttons__black_to_white__text_pressed": "#ffffff",
        "interactive_content__buttons__destructive__fill_default": "#fde5e6",
        "interactive_content__buttons__destructive__fill_hover": "#fde5e6",
        "interactive_content__buttons__destructive__fill_pressed": "#fbcbcd",
        "interactive_content__buttons__destructive__outline_default": "#fde5e6",
        "interactive_content__buttons__destructive__outline_hover": "#f46f74",
        "interactive_content__buttons__destructive__outline_pressed": "#fbcbcd",
        "interactive_content__buttons__destructive__text_default": "#c72127",
        "interactive_content__buttons__destructive__text_hover": "#c72127",
        "interactive_content__buttons__destructive__text_pressed": "#c72127",
        "interactive_content__buttons__ghost__fill_default": "#00000000",
        "interactive_content__buttons__ghost__fill_hover": "#d9dcdf",
        "interactive_content__buttons__ghost__fill_pressed": "#c3c8cd",
        "interactive_content__buttons__ghost__outline_default": "#00000000",
        "interactive_content__buttons__ghost__outline_hover": "#d9dcdf",
        "interactive_content__buttons__ghost__outline_pressed": "#c3c8cd",
        "interactive_content__buttons__ghost__text_default": "#2d2f32",
        "interactive_content__buttons__ghost__text_hover": "#000000",
        "interactive_content__buttons__ghost__text_pressed": "#2d2f32",
        "interactive_content__buttons__outline__fill_default": "#00000000",
        "interactive_content__buttons__outline__fill_hover": "#f5f6f7",
        "interactive_content__buttons__outline__fill_pressed": "#f5f6f7",
        "interactive_content__buttons__outline__outline_default": "#92989f",
        "interactive_content__buttons__outline__outline_hover": "#6f757b",
        "interactive_content__buttons__outline__outline_pressed": "#a7acb1",
        "interactive_content__buttons__outline__text_default": "#2d2f32",
        "interactive_content__buttons__outline__text_hover": "#000000",
        "interactive_content__buttons__outline__text_pressed": "#000000",
        "interactive_content__buttons__primary__fill_default": "#78bf26",
        "interactive_content__buttons__primary__fill_hover": "#6aaa21",
        "interactive_content__buttons__primary__fill_pressed": "#83d02b",
        "interactive_content__buttons__primary__outline_default": "#78bf26",
        "interactive_content__buttons__primary__outline_hover": "#6aaa21",
        "interactive_content__buttons__primary__outline_pressed": "#83d02b",
        "interactive_content__buttons__primary__text_default": "#041752",
        "interactive_content__buttons__primary__text_hover": "#041752",
        "interactive_content__buttons__primary__text_pressed": "#041752",
        "interactive_content__edit_mode__background": "#041752",
        "interactive_content__edit_mode__foreground": "#ffffff",
        "interactive_content__lists__surface_on_hover": "#f1f2f2",
        "interactive_content__lists__surface_on_hover_branded": "#f1f2f2",
        "interactive_content__lists__surface_while_active": "#ebf2ff",
        "interactive_content__lists__surface_while_active_branded": "#ebf2ff",
        "interactive_content__text_link__default": "#085398",
        "interactive_content__tooltips__background": "#000000",
        "interactive_content__tooltips__foreground": "#ffffff",
        "interactive_content__tooltips__icon": "#f5f6f7",
        "unbranded_colors__blue": "#46a8ef",
        "unbranded_colors__green": "#329086",
        "unbranded_colors__purple": "#df57d9",
        "unbranded_colors__red": "#f46f74",
        "unbranded_colors__yellow": "#edd26f",
        "web__authentication__background": "#041752",
        "web__authentication__header_foreground": "#ffffff",
        "web__header__background": "#00000000",
        "web__header__foreground": "#2d2f32",
        "web__navigation__background": "#f9fafa",
        "web__navigation__divider": "#d9dcdf",
        "web__navigation__foreground_default": "#6f757b",
        "web__navigation__foreground_hover": "#041752",
        "web__navigation__foreground_pressed": "#041752",
        "web__upgrade__background": "#f9fafa",
        "web__upgrade__recommended": "#2d2f32",
        "web__upgrade__tab_selection_line": "#2d2f32",
        "web__upgrade__tag": "#f5f6f7",
        "web__upgrade__text_highlight": "#2d2f32",
        "website__paid_signup_custom__background_left": "#ffffff",
        "website__paid_signup_custom__background_logo_icon": "#ffffff",
        "website__paid_signup_custom__background_right": "#f5f6f7",
        "website__paid_signup_custom__divider": "#d9dcdf",
        "website__paid_signup_custom__link": "#085398",
        "website__paid_signup_custom__password_box": "#f1f2f2",
        "website__paid_signup_custom__radio_button": "#0b76d9",
        "website__paid_signup_custom__radio_button_background": "#ebf2ff",
        "website__paid_signup_custom__radio_button_background_hover": "#f9fafa",
        "website__paid_signup_custom__radio_button_stroke_hover": "#0b76d9",
        "website__paid_signup_custom__strong_password": "#5eb2aa",
        "website__paid_signup_custom__subtext_summary": "#5c6166"
      }
    },
    "elgiganten": {
      "colors": {
        "background__critical_danger": "#ef3138",
        "background__critical_warning": "#e4b91e",
        "background__danger": "#fde5e6",
        "background__good": "#d4f7f0",
        "background__grey_1": "#f9fafa",
        "background__grey_2": "#f5f6f7",
        "background__grey_3": "#f1f2f2",
        "background__grey_4": "#ededed",
        "background__grey_5": "#e8e8e8",
        "background__grey_6": "#e3e3e3",
        "background__informative": "#ebf2ff",
        "background__primary": "#ffffff",
        "background__warning": "#faf4d9",
        "black_and_white__always_black": "#000000",
        "black_and_white__always_white": "#ffffff",
        "black_and_white__auto_black_to_white": "#000000",
        "black_and_white__auto_grey_to_black": "#f1f2f2",
        "black_and_white__auto_white_to_black": "#ffffff",
        "border__base": "#a7acb1",
        "border__in_focus": "#085398",
        "border__light_base": "#d9dcdf",
        "border__lightest_base": "#ededed",
        "elements__alert": "#041752",
        "elements__context_menu": "#ffffff",
        "elements__control_element": "#0b76d9",
        "elements__divider": "#a7acb1",
        "elements__file_and_folder_icons__file_background": "#f1f2f2",
        "elements__file_and_folder_icons__file_foreground": "#2d2f32",
        "elements__file_and_folder_icons__folder_background": "#ffffff",
        "elements__file_and_folder_icons__folder_background_active": "#ebf2ff",
        "elements__folder_icons": "#041752",
        "elements__logo": "#78bf26",
        "elements__modal_branded": "#ffffff",
        "elements__modal_unbranded": "#ffffff",
        "email__heading": "#242424",
        "foreground__danger": "#ef3138",
        "foreground__good": "#00685e",
        "foreground__grey_1": "#3d3e40",
        "foreground__grey_2": "#4a4d50",
        "foreground__grey_3": "#5c6166",
        "foreground__grey_4": "#6f757b",
        "foreground__informative": "#085398",
        "foreground__primary": "#2d2f32",
        "foreground__warning": "#e4b91e",
        "interactive_content__badge__1": "#020327",
        "interactive_content__badge__2": "#024206",
        "interactive_content__badge__3": "#080942",
        "interactive_content__badge__4": "#136319",
        "interactive_content__badge__5": "#262875",
        "interactive_content__badge__6": "#2d8234",
        "interactive_content__badge__7": "#3d3f8b",
        "interactive_content__badge__outline": "#ffffff",
        "interactive_content__badge__text": "#ffffff",
        "interactive_content__buttons__black_to_white__fill_default": "#000000",
        "interactive_content__buttons__black_to_white__fill_hover": "#3d3e40",
        "interactive_content__buttons__black_to_white__fill_pressed": "#2d2f32",
        "interactive_content__buttons__black_to_white__outline_default": "#000000",
        "interactive_content__buttons__black_to_white__outline_hover": "#3d3e40",
        "interactive_content__buttons__black_to_white__outline_pressed": "#2d2f32",
        "interactive_content__buttons__black_to_white__text_default": "#f5f6f7",
        "interactive_content__buttons__black_to_white__text_hover": "#ffffff",
        "interactive_content__buttons__black_to_white__text_pressed": "#ffffff",
        "interactive_content__buttons__destructive__fill_default": "#fde5e6",
        "interactive_content__buttons__destructive__fill_hover": "#fde5e6",
        "interactive_content__buttons__destructive__fill_pressed": "#fbcbcd",
        "interactive_content__buttons__destructive__outline_default": "#fde5e6",
        "interactive_content__buttons__destructive__outline_hover": "#f46f74",
        "interactive_content__buttons__destructive__outline_pressed": "#fbcbcd",
        "interactive_content__buttons__destructive__text_default": "#c72127",
        "interactive_content__buttons__destructive__text_hover": "#c72127",
        "interactive_content__buttons__destructive__text_pressed": "#c72127",
        "interactive_content__buttons__ghost__fill_default": "#00000000",
        "interactive_content__buttons__ghost__fill_hover": "#d9dcdf",
        "interactive_content__buttons__ghost__fill_pressed": "#c3c8cd",
        "interactive_content__buttons__ghost__outline_default": "#00000000",
        "interactive_content__buttons__ghost__outline_hover": "#d9dcdf",
        "interactive_content__buttons__ghost__outline_pressed": "#c3c8cd",
        "interactive_content__buttons__ghost__text_default": "#2d2f32",
        "interactive_content__buttons__ghost__text_hover": "#000000",
        "interactive_content__buttons__ghost__text_pressed": "#2d2f32",
        "interactive_content__buttons__outline__fill_default": "#00000000",
        "interactive_content__buttons__outline__fill_hover": "#f5f6f7",
        "interactive_content__buttons__outline__fill_pressed": "#f5f6f7",
        "interactive_content__buttons__outline__outline_default": "#92989f",
        "interactive_content__buttons__outline__outline_hover": "#6f757b",
        "interactive_content__buttons__outline__outline_pressed": "#a7acb1",
        "interactive_content__buttons__outline__text_default": "#2d2f32",
        "interactive_content__buttons__outline__text_hover": "#000000",
        "interactive_content__buttons__outline__text_pressed": "#000000",
        "interactive_content__buttons__primary__fill_default": "#78bf26",
        "interactive_content__buttons__primary__fill_hover": "#6aaa21",
        "interactive_content__buttons__primary__fill_pressed": "#83d02b",
        "interactive_content__buttons__primary__outline_default": "#78bf26",
        "interactive_content__buttons__primary__outline_hover": "#6aaa21",
        "interactive_content__buttons__primary__outline_pressed": "#83d02b",
        "interactive_content__buttons__primary__text_default": "#041752",
        "interactive_content__buttons__primary__text_hover": "#041752",
        "interactive_content__buttons__primary__text_pressed": "#041752",
        "interactive_content__edit_mode__background": "#041752",
        "interactive_content__edit_mode__foreground": "#ffffff",
        "interactive_content__lists__surface_on_hover": "#f1f2f2",
        "interactive_content__lists__surface_on_hover_branded": "#f1f2f2",
        "interactive_content__lists__surface_while_active": "#ebf2ff",
        "interactive_content__lists__surface_while_active_branded": "#ebf2ff",
        "interactive_content__text_link__default": "#085398",
        "interactive_content__tooltips__background": "#000000",
        "interactive_content__tooltips__foreground": "#ffffff",
        "interactive_content__tooltips__icon": "#f5f6f7",
        "unbranded_colors__blue": "#46a8ef",
        "unbranded_colors__green": "#329086",
        "unbranded_colors__purple": "#df57d9",
        "unbranded_colors__red": "#f46f74",
        "unbranded_colors__yellow": "#edd26f",
        "web__authentication__background": "#041752",
        "web__authentication__header_foreground": "#ffffff",
        "web__header__background": "#00000000",
        "web__header__foreground": "#2d2f32",
        "web__navigation__background": "#f9fafa",
        "web__navigation__divider": "#d9dcdf",
        "web__navigation__foreground_default": "#6f757b",
        "web__navigation__foreground_hover": "#041752",
        "web__navigation__foreground_pressed": "#041752",
        "web__upgrade__background": "#f9fafa",
        "web__upgrade__recommended": "#2d2f32",
        "web__upgrade__tab_selection_line": "#2d2f32",
        "web__upgrade__tag": "#f5f6f7",
        "web__upgrade__text_highlight": "#2d2f32",
        "website__paid_signup_custom__background_left": "#ffffff",
        "website__paid_signup_custom__background_logo_icon": "#ffffff",
        "website__paid_signup_custom__background_right": "#f5f6f7",
        "website__paid_signup_custom__divider": "#d9dcdf",
        "website__paid_signup_custom__link": "#085398",
        "website__paid_signup_custom__password_box": "#f1f2f2",
        "website__paid_signup_custom__radio_button": "#0b76d9",
        "website__paid_signup_custom__radio_button_background": "#ebf2ff",
        "website__paid_signup_custom__radio_button_background_hover": "#f9fafa",
        "website__paid_signup_custom__radio_button_stroke_hover": "#0b76d9",
        "website__paid_signup_custom__strong_password": "#5eb2aa",
        "website__paid_signup_custom__subtext_summary": "#5c6166"
      }
    },
    "gigantti": {
      "colors": {
        "background__critical_danger": "#ef3138",
        "background__critical_warning": "#e4b91e",
        "background__danger": "#fde5e6",
        "background__good": "#d4f7f0",
        "background__grey_1": "#f9fafa",
        "background__grey_2": "#f5f6f7",
        "background__grey_3": "#f1f2f2",
        "background__grey_4": "#ededed",
        "background__grey_5": "#e8e8e8",
        "background__grey_6": "#e3e3e3",
        "background__informative": "#ebf2ff",
        "background__primary": "#ffffff",
        "background__warning": "#faf4d9",
        "black_and_white__always_black": "#000000",
        "black_and_white__always_white": "#ffffff",
        "black_and_white__auto_black_to_white": "#000000",
        "black_and_white__auto_grey_to_black": "#f1f2f2",
        "black_and_white__auto_white_to_black": "#ffffff",
        "border__base": "#a7acb1",
        "border__in_focus": "#085398",
        "border__light_base": "#d9dcdf",
        "border__lightest_base": "#ededed",
        "elements__alert": "#041752",
        "elements__context_menu": "#ffffff",
        "elements__control_element": "#0b76d9",
        "elements__divider": "#a7acb1",
        "elements__file_and_folder_icons__file_background": "#f1f2f2",
        "elements__file_and_folder_icons__file_foreground": "#2d2f32",
        "elements__file_and_folder_icons__folder_background": "#ffffff",
        "elements__file_and_folder_icons__folder_background_active": "#ebf2ff",
        "elements__folder_icons": "#041752",
        "elements__logo": "#78bf26",
        "elements__modal_branded": "#ffffff",
        "elements__modal_unbranded": "#ffffff",
        "email__heading": "#242424",
        "foreground__danger": "#ef3138",
        "foreground__good": "#00685e",
        "foreground__grey_1": "#3d3e40",
        "foreground__grey_2": "#4a4d50",
        "foreground__grey_3": "#5c6166",
        "foreground__grey_4": "#6f757b",
        "foreground__informative": "#085398",
        "foreground__primary": "#2d2f32",
        "foreground__warning": "#e4b91e",
        "interactive_content__badge__1": "#020327",
        "interactive_content__badge__2": "#024206",
        "interactive_content__badge__3": "#080942",
        "interactive_content__badge__4": "#136319",
        "interactive_content__badge__5": "#262875",
        "interactive_content__badge__6": "#2d8234",
        "interactive_content__badge__7": "#3d3f8b",
        "interactive_content__badge__outline": "#ffffff",
        "interactive_content__badge__text": "#ffffff",
        "interactive_content__buttons__black_to_white__fill_default": "#000000",
        "interactive_content__buttons__black_to_white__fill_hover": "#3d3e40",
        "interactive_content__buttons__black_to_white__fill_pressed": "#2d2f32",
        "interactive_content__buttons__black_to_white__outline_default": "#000000",
        "interactive_content__buttons__black_to_white__outline_hover": "#3d3e40",
        "interactive_content__buttons__black_to_white__outline_pressed": "#2d2f32",
        "interactive_content__buttons__black_to_white__text_default": "#f5f6f7",
        "interactive_content__buttons__black_to_white__text_hover": "#ffffff",
        "interactive_content__buttons__black_to_white__text_pressed": "#ffffff",
        "interactive_content__buttons__destructive__fill_default": "#fde5e6",
        "interactive_content__buttons__destructive__fill_hover": "#fde5e6",
        "interactive_content__buttons__destructive__fill_pressed": "#fbcbcd",
        "interactive_content__buttons__destructive__outline_default": "#fde5e6",
        "interactive_content__buttons__destructive__outline_hover": "#f46f74",
        "interactive_content__buttons__destructive__outline_pressed": "#fbcbcd",
        "interactive_content__buttons__destructive__text_default": "#c72127",
        "interactive_content__buttons__destructive__text_hover": "#c72127",
        "interactive_content__buttons__destructive__text_pressed": "#c72127",
        "interactive_content__buttons__ghost__fill_default": "#00000000",
        "interactive_content__buttons__ghost__fill_hover": "#d9dcdf",
        "interactive_content__buttons__ghost__fill_pressed": "#c3c8cd",
        "interactive_content__buttons__ghost__outline_default": "#00000000",
        "interactive_content__buttons__ghost__outline_hover": "#d9dcdf",
        "interactive_content__buttons__ghost__outline_pressed": "#c3c8cd",
        "interactive_content__buttons__ghost__text_default": "#2d2f32",
        "interactive_content__buttons__ghost__text_hover": "#000000",
        "interactive_content__buttons__ghost__text_pressed": "#2d2f32",
        "interactive_content__buttons__outline__fill_default": "#00000000",
        "interactive_content__buttons__outline__fill_hover": "#f5f6f7",
        "interactive_content__buttons__outline__fill_pressed": "#f5f6f7",
        "interactive_content__buttons__outline__outline_default": "#92989f",
        "interactive_content__buttons__outline__outline_hover": "#6f757b",
        "interactive_content__buttons__outline__outline_pressed": "#a7acb1",
        "interactive_content__buttons__outline__text_default": "#2d2f32",
        "interactive_content__buttons__outline__text_hover": "#000000",
        "interactive_content__buttons__outline__text_pressed": "#000000",
        "interactive_content__buttons__primary__fill_default": "#78bf26",
        "interactive_content__buttons__primary__fill_hover": "#6aaa21",
        "interactive_content__buttons__primary__fill_pressed": "#83d02b",
        "interactive_content__buttons__primary__outline_default": "#78bf26",
        "interactive_content__buttons__primary__outline_hover": "#6aaa21",
        "interactive_content__buttons__primary__outline_pressed": "#83d02b",
        "interactive_content__buttons__primary__text_default": "#041752",
        "interactive_content__buttons__primary__text_hover": "#041752",
        "interactive_content__buttons__primary__text_pressed": "#041752",
        "interactive_content__edit_mode__background": "#041752",
        "interactive_content__edit_mode__foreground": "#ffffff",
        "interactive_content__lists__surface_on_hover": "#f1f2f2",
        "interactive_content__lists__surface_on_hover_branded": "#f1f2f2",
        "interactive_content__lists__surface_while_active": "#ebf2ff",
        "interactive_content__lists__surface_while_active_branded": "#ebf2ff",
        "interactive_content__text_link__default": "#085398",
        "interactive_content__tooltips__background": "#000000",
        "interactive_content__tooltips__foreground": "#ffffff",
        "interactive_content__tooltips__icon": "#f5f6f7",
        "unbranded_colors__blue": "#46a8ef",
        "unbranded_colors__green": "#329086",
        "unbranded_colors__purple": "#df57d9",
        "unbranded_colors__red": "#f46f74",
        "unbranded_colors__yellow": "#edd26f",
        "web__authentication__background": "#041752",
        "web__authentication__header_foreground": "#ffffff",
        "web__header__background": "#00000000",
        "web__header__foreground": "#2d2f32",
        "web__navigation__background": "#f9fafa",
        "web__navigation__divider": "#d9dcdf",
        "web__navigation__foreground_default": "#6f757b",
        "web__navigation__foreground_hover": "#041752",
        "web__navigation__foreground_pressed": "#041752",
        "web__upgrade__background": "#f9fafa",
        "web__upgrade__recommended": "#2d2f32",
        "web__upgrade__tab_selection_line": "#2d2f32",
        "web__upgrade__tag": "#f5f6f7",
        "web__upgrade__text_highlight": "#2d2f32",
        "website__paid_signup_custom__background_left": "#ffffff",
        "website__paid_signup_custom__background_logo_icon": "#ffffff",
        "website__paid_signup_custom__background_right": "#f5f6f7",
        "website__paid_signup_custom__divider": "#d9dcdf",
        "website__paid_signup_custom__link": "#085398",
        "website__paid_signup_custom__password_box": "#f1f2f2",
        "website__paid_signup_custom__radio_button": "#0b76d9",
        "website__paid_signup_custom__radio_button_background": "#ebf2ff",
        "website__paid_signup_custom__radio_button_background_hover": "#f9fafa",
        "website__paid_signup_custom__radio_button_stroke_hover": "#0b76d9",
        "website__paid_signup_custom__strong_password": "#5eb2aa",
        "website__paid_signup_custom__subtext_summary": "#5c6166"
      }
    },
    "elko": {
      "colors": {
        "background__critical_danger": "#ef3138",
        "background__critical_warning": "#e4b91e",
        "background__danger": "#fde5e6",
        "background__good": "#d4f7f0",
        "background__grey_1": "#f9fafa",
        "background__grey_2": "#f5f6f7",
        "background__grey_3": "#f1f2f2",
        "background__grey_4": "#ededed",
        "background__grey_5": "#e8e8e8",
        "background__grey_6": "#e3e3e3",
        "background__informative": "#ebf2ff",
        "background__primary": "#ffffff",
        "background__warning": "#faf4d9",
        "black_and_white__always_black": "#000000",
        "black_and_white__always_white": "#ffffff",
        "black_and_white__auto_black_to_white": "#000000",
        "black_and_white__auto_grey_to_black": "#f1f2f2",
        "black_and_white__auto_white_to_black": "#ffffff",
        "border__base": "#a7acb1",
        "border__in_focus": "#085398",
        "border__light_base": "#d9dcdf",
        "border__lightest_base": "#ededed",
        "elements__alert": "#041752",
        "elements__context_menu": "#ffffff",
        "elements__control_element": "#0b76d9",
        "elements__divider": "#a7acb1",
        "elements__file_and_folder_icons__file_background": "#f1f2f2",
        "elements__file_and_folder_icons__file_foreground": "#2d2f32",
        "elements__file_and_folder_icons__folder_background": "#ffffff",
        "elements__file_and_folder_icons__folder_background_active": "#ebf2ff",
        "elements__folder_icons": "#041752",
        "elements__logo": "#78bf26",
        "elements__modal_branded": "#ffffff",
        "elements__modal_unbranded": "#ffffff",
        "email__heading": "#242424",
        "foreground__danger": "#ef3138",
        "foreground__good": "#00685e",
        "foreground__grey_1": "#3d3e40",
        "foreground__grey_2": "#4a4d50",
        "foreground__grey_3": "#5c6166",
        "foreground__grey_4": "#6f757b",
        "foreground__informative": "#085398",
        "foreground__primary": "#2d2f32",
        "foreground__warning": "#e4b91e",
        "interactive_content__badge__1": "#020327",
        "interactive_content__badge__2": "#024206",
        "interactive_content__badge__3": "#080942",
        "interactive_content__badge__4": "#136319",
        "interactive_content__badge__5": "#262875",
        "interactive_content__badge__6": "#2d8234",
        "interactive_content__badge__7": "#3d3f8b",
        "interactive_content__badge__outline": "#ffffff",
        "interactive_content__badge__text": "#ffffff",
        "interactive_content__buttons__black_to_white__fill_default": "#000000",
        "interactive_content__buttons__black_to_white__fill_hover": "#3d3e40",
        "interactive_content__buttons__black_to_white__fill_pressed": "#2d2f32",
        "interactive_content__buttons__black_to_white__outline_default": "#000000",
        "interactive_content__buttons__black_to_white__outline_hover": "#3d3e40",
        "interactive_content__buttons__black_to_white__outline_pressed": "#2d2f32",
        "interactive_content__buttons__black_to_white__text_default": "#f5f6f7",
        "interactive_content__buttons__black_to_white__text_hover": "#ffffff",
        "interactive_content__buttons__black_to_white__text_pressed": "#ffffff",
        "interactive_content__buttons__destructive__fill_default": "#fde5e6",
        "interactive_content__buttons__destructive__fill_hover": "#fde5e6",
        "interactive_content__buttons__destructive__fill_pressed": "#fbcbcd",
        "interactive_content__buttons__destructive__outline_default": "#fde5e6",
        "interactive_content__buttons__destructive__outline_hover": "#f46f74",
        "interactive_content__buttons__destructive__outline_pressed": "#fbcbcd",
        "interactive_content__buttons__destructive__text_default": "#c72127",
        "interactive_content__buttons__destructive__text_hover": "#c72127",
        "interactive_content__buttons__destructive__text_pressed": "#c72127",
        "interactive_content__buttons__ghost__fill_default": "#00000000",
        "interactive_content__buttons__ghost__fill_hover": "#d9dcdf",
        "interactive_content__buttons__ghost__fill_pressed": "#c3c8cd",
        "interactive_content__buttons__ghost__outline_default": "#00000000",
        "interactive_content__buttons__ghost__outline_hover": "#d9dcdf",
        "interactive_content__buttons__ghost__outline_pressed": "#c3c8cd",
        "interactive_content__buttons__ghost__text_default": "#2d2f32",
        "interactive_content__buttons__ghost__text_hover": "#000000",
        "interactive_content__buttons__ghost__text_pressed": "#2d2f32",
        "interactive_content__buttons__outline__fill_default": "#00000000",
        "interactive_content__buttons__outline__fill_hover": "#f5f6f7",
        "interactive_content__buttons__outline__fill_pressed": "#f5f6f7",
        "interactive_content__buttons__outline__outline_default": "#92989f",
        "interactive_content__buttons__outline__outline_hover": "#6f757b",
        "interactive_content__buttons__outline__outline_pressed": "#a7acb1",
        "interactive_content__buttons__outline__text_default": "#2d2f32",
        "interactive_content__buttons__outline__text_hover": "#000000",
        "interactive_content__buttons__outline__text_pressed": "#000000",
        "interactive_content__buttons__primary__fill_default": "#78bf26",
        "interactive_content__buttons__primary__fill_hover": "#6aaa21",
        "interactive_content__buttons__primary__fill_pressed": "#83d02b",
        "interactive_content__buttons__primary__outline_default": "#78bf26",
        "interactive_content__buttons__primary__outline_hover": "#6aaa21",
        "interactive_content__buttons__primary__outline_pressed": "#83d02b",
        "interactive_content__buttons__primary__text_default": "#041752",
        "interactive_content__buttons__primary__text_hover": "#041752",
        "interactive_content__buttons__primary__text_pressed": "#041752",
        "interactive_content__edit_mode__background": "#041752",
        "interactive_content__edit_mode__foreground": "#ffffff",
        "interactive_content__lists__surface_on_hover": "#f1f2f2",
        "interactive_content__lists__surface_on_hover_branded": "#f1f2f2",
        "interactive_content__lists__surface_while_active": "#ebf2ff",
        "interactive_content__lists__surface_while_active_branded": "#ebf2ff",
        "interactive_content__text_link__default": "#085398",
        "interactive_content__tooltips__background": "#000000",
        "interactive_content__tooltips__foreground": "#ffffff",
        "interactive_content__tooltips__icon": "#f5f6f7",
        "unbranded_colors__blue": "#46a8ef",
        "unbranded_colors__green": "#329086",
        "unbranded_colors__purple": "#df57d9",
        "unbranded_colors__red": "#f46f74",
        "unbranded_colors__yellow": "#edd26f",
        "web__authentication__background": "#041752",
        "web__authentication__header_foreground": "#ffffff",
        "web__header__background": "#00000000",
        "web__header__foreground": "#2d2f32",
        "web__navigation__background": "#f9fafa",
        "web__navigation__divider": "#d9dcdf",
        "web__navigation__foreground_default": "#6f757b",
        "web__navigation__foreground_hover": "#041752",
        "web__navigation__foreground_pressed": "#041752",
        "web__upgrade__background": "#f9fafa",
        "web__upgrade__recommended": "#2d2f32",
        "web__upgrade__tab_selection_line": "#2d2f32",
        "web__upgrade__tag": "#f5f6f7",
        "web__upgrade__text_highlight": "#2d2f32",
        "website__paid_signup_custom__background_left": "#ffffff",
        "website__paid_signup_custom__background_logo_icon": "#ffffff",
        "website__paid_signup_custom__background_right": "#f5f6f7",
        "website__paid_signup_custom__divider": "#d9dcdf",
        "website__paid_signup_custom__link": "#085398",
        "website__paid_signup_custom__password_box": "#f1f2f2",
        "website__paid_signup_custom__radio_button": "#0b76d9",
        "website__paid_signup_custom__radio_button_background": "#ebf2ff",
        "website__paid_signup_custom__radio_button_background_hover": "#f9fafa",
        "website__paid_signup_custom__radio_button_stroke_hover": "#0b76d9",
        "website__paid_signup_custom__strong_password": "#5eb2aa",
        "website__paid_signup_custom__subtext_summary": "#5c6166"
      }
    },
    "mediamarkt": {
      "colors": {
        "background__critical_danger": "#ef3138",
        "background__critical_warning": "#e4b91e",
        "background__danger": "#fde5e6",
        "background__good": "#d4f7f0",
        "background__grey_1": "#f9fafa",
        "background__grey_2": "#f5f6f7",
        "background__grey_3": "#f1f2f2",
        "background__grey_4": "#ededed",
        "background__grey_5": "#e8e8e8",
        "background__grey_6": "#e3e3e3",
        "background__informative": "#ebf2ff",
        "background__primary": "#ffffff",
        "background__warning": "#faf4d9",
        "black_and_white__always_black": "#000000",
        "black_and_white__always_white": "#ffffff",
        "black_and_white__auto_black_to_white": "#000000",
        "black_and_white__auto_grey_to_black": "#f1f2f2",
        "black_and_white__auto_white_to_black": "#ffffff",
        "border__base": "#a7acb1",
        "border__in_focus": "#085398",
        "border__light_base": "#d9dcdf",
        "border__lightest_base": "#ededed",
        "elements__alert": "#272422",
        "elements__context_menu": "#ffffff",
        "elements__control_element": "#0b76d9",
        "elements__divider": "#a7acb1",
        "elements__file_and_folder_icons__file_background": "#f1f2f2",
        "elements__file_and_folder_icons__file_foreground": "#2d2f32",
        "elements__file_and_folder_icons__folder_background": "#ffffff",
        "elements__file_and_folder_icons__folder_background_active": "#ebf2ff",
        "elements__folder_icons": "#272422",
        "elements__logo": "#df0000",
        "elements__modal_branded": "#ffffff",
        "elements__modal_unbranded": "#ffffff",
        "email__heading": "#df0000",
        "foreground__danger": "#ef3138",
        "foreground__good": "#00685e",
        "foreground__grey_1": "#3d3e40",
        "foreground__grey_2": "#4a4d50",
        "foreground__grey_3": "#5c6166",
        "foreground__grey_4": "#6f757b",
        "foreground__informative": "#085398",
        "foreground__primary": "#2d2f32",
        "foreground__warning": "#e4b91e",
        "interactive_content__badge__1": "#201d1d",
        "interactive_content__badge__2": "#444444",
        "interactive_content__badge__3": "#8b0000",
        "interactive_content__badge__4": "#b40000",
        "interactive_content__badge__5": "#fe2727",
        "interactive_content__badge__6": "#ff5656",
        "interactive_content__badge__7": "#ff5656",
        "interactive_content__badge__outline": "#ffffff",
        "interactive_content__badge__text": "#ffffff",
        "interactive_content__buttons__black_to_white__fill_default": "#000000",
        "interactive_content__buttons__black_to_white__fill_hover": "#3d3e40",
        "interactive_content__buttons__black_to_white__fill_pressed": "#2d2f32",
        "interactive_content__buttons__black_to_white__outline_default": "#000000",
        "interactive_content__buttons__black_to_white__outline_hover": "#3d3e40",
        "interactive_content__buttons__black_to_white__outline_pressed": "#2d2f32",
        "interactive_content__buttons__black_to_white__text_default": "#f5f6f7",
        "interactive_content__buttons__black_to_white__text_hover": "#ffffff",
        "interactive_content__buttons__black_to_white__text_pressed": "#ffffff",
        "interactive_content__buttons__destructive__fill_default": "#fde5e6",
        "interactive_content__buttons__destructive__fill_hover": "#fde5e6",
        "interactive_content__buttons__destructive__fill_pressed": "#fbcbcd",
        "interactive_content__buttons__destructive__outline_default": "#fde5e6",
        "interactive_content__buttons__destructive__outline_hover": "#f46f74",
        "interactive_content__buttons__destructive__outline_pressed": "#fbcbcd",
        "interactive_content__buttons__destructive__text_default": "#c72127",
        "interactive_content__buttons__destructive__text_hover": "#c72127",
        "interactive_content__buttons__destructive__text_pressed": "#c72127",
        "interactive_content__buttons__ghost__fill_default": "#00000000",
        "interactive_content__buttons__ghost__fill_hover": "#d9dcdf",
        "interactive_content__buttons__ghost__fill_pressed": "#c3c8cd",
        "interactive_content__buttons__ghost__outline_default": "#00000000",
        "interactive_content__buttons__ghost__outline_hover": "#d9dcdf",
        "interactive_content__buttons__ghost__outline_pressed": "#c3c8cd",
        "interactive_content__buttons__ghost__text_default": "#2d2f32",
        "interactive_content__buttons__ghost__text_hover": "#000000",
        "interactive_content__buttons__ghost__text_pressed": "#2d2f32",
        "interactive_content__buttons__outline__fill_default": "#00000000",
        "interactive_content__buttons__outline__fill_hover": "#f5f6f7",
        "interactive_content__buttons__outline__fill_pressed": "#f5f6f7",
        "interactive_content__buttons__outline__outline_default": "#92989f",
        "interactive_content__buttons__outline__outline_hover": "#6f757b",
        "interactive_content__buttons__outline__outline_pressed": "#a7acb1",
        "interactive_content__buttons__outline__text_default": "#2d2f32",
        "interactive_content__buttons__outline__text_hover": "#000000",
        "interactive_content__buttons__outline__text_pressed": "#000000",
        "interactive_content__buttons__primary__fill_default": "#000000",
        "interactive_content__buttons__primary__fill_hover": "#4a4d50",
        "interactive_content__buttons__primary__fill_pressed": "#2d2f32",
        "interactive_content__buttons__primary__outline_default": "#000000",
        "interactive_content__buttons__primary__outline_hover": "#4a4d50",
        "interactive_content__buttons__primary__outline_pressed": "#2d2f32",
        "interactive_content__buttons__primary__text_default": "#ffffff",
        "interactive_content__buttons__primary__text_hover": "#ffffff",
        "interactive_content__buttons__primary__text_pressed": "#ffffff",
        "interactive_content__edit_mode__background": "#000000",
        "interactive_content__edit_mode__foreground": "#ffffff",
        "interactive_content__lists__surface_on_hover": "#f1f2f2",
        "interactive_content__lists__surface_on_hover_branded": "#f1f2f2",
        "interactive_content__lists__surface_while_active": "#ebf2ff",
        "interactive_content__lists__surface_while_active_branded": "#ebf2ff",
        "interactive_content__text_link__default": "#085398",
        "interactive_content__tooltips__background": "#000000",
        "interactive_content__tooltips__foreground": "#ffffff",
        "interactive_content__tooltips__icon": "#f5f6f7",
        "unbranded_colors__blue": "#46a8ef",
        "unbranded_colors__green": "#329086",
        "unbranded_colors__purple": "#df57d9",
        "unbranded_colors__red": "#f46f74",
        "unbranded_colors__yellow": "#edd26f",
        "web__authentication__background": "#df0000",
        "web__authentication__header_foreground": "#ffffff",
        "web__header__background": "#df0000",
        "web__header__foreground": "#f5f6f7",
        "web__navigation__background": "#f9fafa",
        "web__navigation__divider": "#d9dcdf",
        "web__navigation__foreground_default": "#6f757b",
        "web__navigation__foreground_hover": "#000000",
        "web__navigation__foreground_pressed": "#000000",
        "web__upgrade__background": "#f9fafa",
        "web__upgrade__recommended": "#2d2f32",
        "web__upgrade__tab_selection_line": "#2d2f32",
        "web__upgrade__tag": "#f5f6f7",
        "web__upgrade__text_highlight": "#2d2f32",
        "website__paid_signup_custom__background_left": "#ffffff",
        "website__paid_signup_custom__background_logo_icon": "#ffffff",
        "website__paid_signup_custom__background_right": "#f5f6f7",
        "website__paid_signup_custom__divider": "#d9dcdf",
        "website__paid_signup_custom__link": "#085398",
        "website__paid_signup_custom__password_box": "#f1f2f2",
        "website__paid_signup_custom__radio_button": "#0b76d9",
        "website__paid_signup_custom__radio_button_background": "#ebf2ff",
        "website__paid_signup_custom__radio_button_background_hover": "#f9fafa",
        "website__paid_signup_custom__radio_button_stroke_hover": "#0b76d9",
        "website__paid_signup_custom__strong_password": "#5eb2aa",
        "website__paid_signup_custom__subtext_summary": "#5c6166"
      }
    },
    "saturn": {
      "colors": {
        "background__critical_danger": "#ef3138",
        "background__critical_warning": "#e4b91e",
        "background__danger": "#fde5e6",
        "background__good": "#d4f7f0",
        "background__grey_1": "#f9fafa",
        "background__grey_2": "#f5f6f7",
        "background__grey_3": "#f1f2f2",
        "background__grey_4": "#ededed",
        "background__grey_5": "#e8e8e8",
        "background__grey_6": "#e3e3e3",
        "background__informative": "#ebf2ff",
        "background__primary": "#ffffff",
        "background__warning": "#faf4d9",
        "black_and_white__always_black": "#000000",
        "black_and_white__always_white": "#ffffff",
        "black_and_white__auto_black_to_white": "#000000",
        "black_and_white__auto_grey_to_black": "#f1f2f2",
        "black_and_white__auto_white_to_black": "#ffffff",
        "border__base": "#a7acb1",
        "border__in_focus": "#085398",
        "border__light_base": "#d9dcdf",
        "border__lightest_base": "#ededed",
        "elements__alert": "#ef7c00",
        "elements__context_menu": "#ffffff",
        "elements__control_element": "#46a8ef",
        "elements__divider": "#a7acb1",
        "elements__file_and_folder_icons__file_background": "#f1f2f2",
        "elements__file_and_folder_icons__file_foreground": "#2d2f32",
        "elements__file_and_folder_icons__folder_background": "#ffffff",
        "elements__file_and_folder_icons__folder_background_active": "#ebf2ff",
        "elements__folder_icons": "#ef7c00",
        "elements__logo": "#ef7c00",
        "elements__modal_branded": "#ffffff",
        "elements__modal_unbranded": "#ffffff",
        "email__heading": "#282f33",
        "foreground__danger": "#ef3138",
        "foreground__good": "#00685e",
        "foreground__grey_1": "#3d3e40",
        "foreground__grey_2": "#4a4d50",
        "foreground__grey_3": "#5c6166",
        "foreground__grey_4": "#6f757b",
        "foreground__informative": "#085398",
        "foreground__primary": "#2d2f32",
        "foreground__warning": "#e4b91e",
        "interactive_content__badge__1": "#009fe3",
        "interactive_content__badge__2": "#30a65d",
        "interactive_content__badge__3": "#418ec6",
        "interactive_content__badge__4": "#445258",
        "interactive_content__badge__5": "#e30613",
        "interactive_content__badge__6": "#ef7c00",
        "interactive_content__badge__7": "#000000",
        "interactive_content__badge__outline": "#ffffff",
        "interactive_content__badge__text": "#ffffff",
        "interactive_content__buttons__black_to_white__fill_default": "#000000",
        "interactive_content__buttons__black_to_white__fill_hover": "#3d3e40",
        "interactive_content__buttons__black_to_white__fill_pressed": "#2d2f32",
        "interactive_content__buttons__black_to_white__outline_default": "#000000",
        "interactive_content__buttons__black_to_white__outline_hover": "#3d3e40",
        "interactive_content__buttons__black_to_white__outline_pressed": "#2d2f32",
        "interactive_content__buttons__black_to_white__text_default": "#f5f6f7",
        "interactive_content__buttons__black_to_white__text_hover": "#ffffff",
        "interactive_content__buttons__black_to_white__text_pressed": "#ffffff",
        "interactive_content__buttons__destructive__fill_default": "#fde5e6",
        "interactive_content__buttons__destructive__fill_hover": "#fde5e6",
        "interactive_content__buttons__destructive__fill_pressed": "#fbcbcd",
        "interactive_content__buttons__destructive__outline_default": "#fde5e6",
        "interactive_content__buttons__destructive__outline_hover": "#f46f74",
        "interactive_content__buttons__destructive__outline_pressed": "#fbcbcd",
        "interactive_content__buttons__destructive__text_default": "#c72127",
        "interactive_content__buttons__destructive__text_hover": "#c72127",
        "interactive_content__buttons__destructive__text_pressed": "#c72127",
        "interactive_content__buttons__ghost__fill_default": "#00000000",
        "interactive_content__buttons__ghost__fill_hover": "#d9dcdf",
        "interactive_content__buttons__ghost__fill_pressed": "#c3c8cd",
        "interactive_content__buttons__ghost__outline_default": "#00000000",
        "interactive_content__buttons__ghost__outline_hover": "#d9dcdf",
        "interactive_content__buttons__ghost__outline_pressed": "#c3c8cd",
        "interactive_content__buttons__ghost__text_default": "#2d2f32",
        "interactive_content__buttons__ghost__text_hover": "#000000",
        "interactive_content__buttons__ghost__text_pressed": "#2d2f32",
        "interactive_content__buttons__outline__fill_default": "#00000000",
        "interactive_content__buttons__outline__fill_hover": "#f5f6f7",
        "interactive_content__buttons__outline__fill_pressed": "#f5f6f7",
        "interactive_content__buttons__outline__outline_default": "#92989f",
        "interactive_content__buttons__outline__outline_hover": "#6f757b",
        "interactive_content__buttons__outline__outline_pressed": "#a7acb1",
        "interactive_content__buttons__outline__text_default": "#2d2f32",
        "interactive_content__buttons__outline__text_hover": "#000000",
        "interactive_content__buttons__outline__text_pressed": "#000000",
        "interactive_content__buttons__primary__fill_default": "#ef7c00",
        "interactive_content__buttons__primary__fill_hover": "#e57200",
        "interactive_content__buttons__primary__fill_pressed": "#db6800",
        "interactive_content__buttons__primary__outline_default": "#ef7c00",
        "interactive_content__buttons__primary__outline_hover": "#e57200",
        "interactive_content__buttons__primary__outline_pressed": "#db6800",
        "interactive_content__buttons__primary__text_default": "#ffffff",
        "interactive_content__buttons__primary__text_hover": "#ffffff",
        "interactive_content__buttons__primary__text_pressed": "#ffffff",
        "interactive_content__edit_mode__background": "#ef7c00",
        "interactive_content__edit_mode__foreground": "#ffffff",
        "interactive_content__lists__surface_on_hover": "#ededed",
        "interactive_content__lists__surface_on_hover_branded": "#f1f2f2",
        "interactive_content__lists__surface_while_active": "#ebf2ff",
        "interactive_content__lists__surface_while_active_branded": "#ebf2ff",
        "interactive_content__text_link__default": "#085398",
        "interactive_content__tooltips__background": "#000000",
        "interactive_content__tooltips__foreground": "#ffffff",
        "interactive_content__tooltips__icon": "#f5f6f7",
        "unbranded_colors__blue": "#46a8ef",
        "unbranded_colors__green": "#329086",
        "unbranded_colors__purple": "#df57d9",
        "unbranded_colors__red": "#f46f74",
        "unbranded_colors__yellow": "#edd26f",
        "web__authentication__background": "#f9fafa",
        "web__authentication__header_foreground": "#2d2f32",
        "web__header__background": "#00000000",
        "web__header__foreground": "#2d2f32",
        "web__navigation__background": "#f9fafa",
        "web__navigation__divider": "#d9dcdf",
        "web__navigation__foreground_default": "#6f757b",
        "web__navigation__foreground_hover": "#000000",
        "web__navigation__foreground_pressed": "#000000",
        "web__upgrade__background": "#f9fafa",
        "web__upgrade__recommended": "#2d2f32",
        "web__upgrade__tab_selection_line": "#2d2f32",
        "web__upgrade__tag": "#f5f6f7",
        "web__upgrade__text_highlight": "#2d2f32",
        "website__paid_signup_custom__background_left": "#ffffff",
        "website__paid_signup_custom__background_logo_icon": "#ffffff",
        "website__paid_signup_custom__background_right": "#f5f6f7",
        "website__paid_signup_custom__divider": "#d9dcdf",
        "website__paid_signup_custom__link": "#ef7c00",
        "website__paid_signup_custom__password_box": "#f1f2f2",
        "website__paid_signup_custom__radio_button": "#0b76d9",
        "website__paid_signup_custom__radio_button_background": "#ebf2ff",
        "website__paid_signup_custom__radio_button_background_hover": "#f9fafa",
        "website__paid_signup_custom__radio_button_stroke_hover": "#0b76d9",
        "website__paid_signup_custom__strong_password": "#5eb2aa",
        "website__paid_signup_custom__subtext_summary": "#5c6166"
      }
    },
    "tele2": {
      "colors": {
        "background__critical_danger": "#ef3138",
        "background__critical_warning": "#e4b91e",
        "background__danger": "#fde5e6",
        "background__good": "#d4f7f0",
        "background__grey_1": "#f9fafa",
        "background__grey_2": "#f5f6f7",
        "background__grey_3": "#f1f2f2",
        "background__grey_4": "#ededed",
        "background__grey_5": "#e8e8e8",
        "background__grey_6": "#e3e3e3",
        "background__informative": "#ebf2ff",
        "background__primary": "#ffffff",
        "background__warning": "#faf4d9",
        "black_and_white__always_black": "#000000",
        "black_and_white__always_white": "#ffffff",
        "black_and_white__auto_black_to_white": "#000000",
        "black_and_white__auto_grey_to_black": "#f1f2f2",
        "black_and_white__auto_white_to_black": "#ffffff",
        "border__base": "#a7acb1",
        "border__in_focus": "#085398",
        "border__light_base": "#d9dcdf",
        "border__lightest_base": "#ededed",
        "elements__alert": "#030f1c",
        "elements__context_menu": "#ffffff",
        "elements__control_element": "#0b76d9",
        "elements__divider": "#a7acb1",
        "elements__file_and_folder_icons__file_background": "#f1f2f2",
        "elements__file_and_folder_icons__file_foreground": "#2d2f32",
        "elements__file_and_folder_icons__folder_background": "#ffffff",
        "elements__file_and_folder_icons__folder_background_active": "#ebf2ff",
        "elements__folder_icons": "#030f1c",
        "elements__logo": "#ffffff",
        "elements__modal_branded": "#ffffff",
        "elements__modal_unbranded": "#ffffff",
        "email__heading": "#030f1c",
        "foreground__danger": "#ef3138",
        "foreground__good": "#00685e",
        "foreground__grey_1": "#3d3e40",
        "foreground__grey_2": "#4a4d50",
        "foreground__grey_3": "#5c6166",
        "foreground__grey_4": "#6f757b",
        "foreground__informative": "#085398",
        "foreground__primary": "#2d2f32",
        "foreground__warning": "#e4b91e",
        "interactive_content__badge__1": "#059b41",
        "interactive_content__badge__2": "#a064dc",
        "interactive_content__badge__3": "#a5dc00",
        "interactive_content__badge__4": "#ff2d1e",
        "interactive_content__badge__5": "#ff55aa",
        "interactive_content__badge__6": "#ff7d00",
        "interactive_content__badge__7": "#ffcd00",
        "interactive_content__badge__outline": "#ffffff",
        "interactive_content__badge__text": "#ffffff",
        "interactive_content__buttons__black_to_white__fill_default": "#000000",
        "interactive_content__buttons__black_to_white__fill_hover": "#3d3e40",
        "interactive_content__buttons__black_to_white__fill_pressed": "#2d2f32",
        "interactive_content__buttons__black_to_white__outline_default": "#000000",
        "interactive_content__buttons__black_to_white__outline_hover": "#3d3e40",
        "interactive_content__buttons__black_to_white__outline_pressed": "#2d2f32",
        "interactive_content__buttons__black_to_white__text_default": "#f5f6f7",
        "interactive_content__buttons__black_to_white__text_hover": "#ffffff",
        "interactive_content__buttons__black_to_white__text_pressed": "#ffffff",
        "interactive_content__buttons__destructive__fill_default": "#fde5e6",
        "interactive_content__buttons__destructive__fill_hover": "#fde5e6",
        "interactive_content__buttons__destructive__fill_pressed": "#fbcbcd",
        "interactive_content__buttons__destructive__outline_default": "#fde5e6",
        "interactive_content__buttons__destructive__outline_hover": "#f46f74",
        "interactive_content__buttons__destructive__outline_pressed": "#fbcbcd",
        "interactive_content__buttons__destructive__text_default": "#c72127",
        "interactive_content__buttons__destructive__text_hover": "#c72127",
        "interactive_content__buttons__destructive__text_pressed": "#c72127",
        "interactive_content__buttons__ghost__fill_default": "#00000000",
        "interactive_content__buttons__ghost__fill_hover": "#d9dcdf",
        "interactive_content__buttons__ghost__fill_pressed": "#c3c8cd",
        "interactive_content__buttons__ghost__outline_default": "#00000000",
        "interactive_content__buttons__ghost__outline_hover": "#d9dcdf",
        "interactive_content__buttons__ghost__outline_pressed": "#c3c8cd",
        "interactive_content__buttons__ghost__text_default": "#2d2f32",
        "interactive_content__buttons__ghost__text_hover": "#000000",
        "interactive_content__buttons__ghost__text_pressed": "#2d2f32",
        "interactive_content__buttons__outline__fill_default": "#00000000",
        "interactive_content__buttons__outline__fill_hover": "#f5f6f7",
        "interactive_content__buttons__outline__fill_pressed": "#f5f6f7",
        "interactive_content__buttons__outline__outline_default": "#92989f",
        "interactive_content__buttons__outline__outline_hover": "#6f757b",
        "interactive_content__buttons__outline__outline_pressed": "#a7acb1",
        "interactive_content__buttons__outline__text_default": "#2d2f32",
        "interactive_content__buttons__outline__text_hover": "#000000",
        "interactive_content__buttons__outline__text_pressed": "#000000",
        "interactive_content__buttons__primary__fill_default": "#030f1c",
        "interactive_content__buttons__primary__fill_hover": "#0d1926",
        "interactive_content__buttons__primary__fill_pressed": "#000512",
        "interactive_content__buttons__primary__outline_default": "#030f1c",
        "interactive_content__buttons__primary__outline_hover": "#0d1926",
        "interactive_content__buttons__primary__outline_pressed": "#000512",
        "interactive_content__buttons__primary__text_default": "#ffffff",
        "interactive_content__buttons__primary__text_hover": "#ffffff",
        "interactive_content__buttons__primary__text_pressed": "#ffffff",
        "interactive_content__edit_mode__background": "#030f1c",
        "interactive_content__edit_mode__foreground": "#ffffff",
        "interactive_content__lists__surface_on_hover": "#f1f2f2",
        "interactive_content__lists__surface_on_hover_branded": "#f1f2f2",
        "interactive_content__lists__surface_while_active": "#ebf2ff",
        "interactive_content__lists__surface_while_active_branded": "#ebf2ff",
        "interactive_content__text_link__default": "#085398",
        "interactive_content__tooltips__background": "#000000",
        "interactive_content__tooltips__foreground": "#ffffff",
        "interactive_content__tooltips__icon": "#f5f6f7",
        "unbranded_colors__blue": "#46a8ef",
        "unbranded_colors__green": "#329086",
        "unbranded_colors__purple": "#df57d9",
        "unbranded_colors__red": "#f46f74",
        "unbranded_colors__yellow": "#edd26f",
        "web__authentication__background": "#030f1c",
        "web__authentication__header_foreground": "#ffffff",
        "web__header__background": "#ffffff00",
        "web__header__foreground": "#2d2f32",
        "web__navigation__background": "#f9fafa",
        "web__navigation__divider": "#d9dcdf",
        "web__navigation__foreground_default": "#6f757b",
        "web__navigation__foreground_hover": "#030f1c",
        "web__navigation__foreground_pressed": "#030f1c",
        "web__upgrade__background": "#f9fafa",
        "web__upgrade__recommended": "#2d2f32",
        "web__upgrade__tab_selection_line": "#2d2f32",
        "web__upgrade__tag": "#f5f6f7",
        "web__upgrade__text_highlight": "#2d2f32",
        "website__paid_signup_custom__background_left": "#ffffff",
        "website__paid_signup_custom__background_logo_icon": "#ffffff",
        "website__paid_signup_custom__background_right": "#f5f6f7",
        "website__paid_signup_custom__divider": "#d9dcdf",
        "website__paid_signup_custom__link": "#19334b",
        "website__paid_signup_custom__password_box": "#f1f2f2",
        "website__paid_signup_custom__radio_button": "#0b76d9",
        "website__paid_signup_custom__radio_button_background": "#ebf2ff",
        "website__paid_signup_custom__radio_button_background_hover": "#0b76d9",
        "website__paid_signup_custom__radio_button_stroke_hover": "#0b76d9",
        "website__paid_signup_custom__strong_password": "#5eb2aa",
        "website__paid_signup_custom__subtext_summary": "#5c6166"
      }
    },
    "teliasky": {
      "colors": {
        "background__critical_danger": "#ef3138",
        "background__critical_warning": "#e4b91e",
        "background__danger": "#fde5e6",
        "background__good": "#d4f7f0",
        "background__grey_1": "#f9fafa",
        "background__grey_2": "#f5f6f7",
        "background__grey_3": "#f1f2f2",
        "background__grey_4": "#ededed",
        "background__grey_5": "#e8e8e8",
        "background__grey_6": "#e3e3e3",
        "background__informative": "#ebf2ff",
        "background__primary": "#ffffff",
        "background__warning": "#faf4d9",
        "black_and_white__always_black": "#000000",
        "black_and_white__always_white": "#ffffff",
        "black_and_white__auto_black_to_white": "#000000",
        "black_and_white__auto_grey_to_black": "#f1f2f2",
        "black_and_white__auto_white_to_black": "#ffffff",
        "border__base": "#a7acb1",
        "border__in_focus": "#085398",
        "border__light_base": "#d9dcdf",
        "border__lightest_base": "#ededed",
        "elements__alert": "#47096f",
        "elements__context_menu": "#ffffff",
        "elements__control_element": "#0b76d9",
        "elements__divider": "#a7acb1",
        "elements__file_and_folder_icons__file_background": "#f1f2f2",
        "elements__file_and_folder_icons__file_foreground": "#2d2f32",
        "elements__file_and_folder_icons__folder_background": "#ffffff",
        "elements__file_and_folder_icons__folder_background_active": "#ebf2ff",
        "elements__folder_icons": "#47096f",
        "elements__logo": "#47096f",
        "elements__modal_branded": "#ffffff",
        "elements__modal_unbranded": "#ffffff",
        "email__heading": "#29003e",
        "foreground__danger": "#ef3138",
        "foreground__good": "#00685e",
        "foreground__grey_1": "#3d3e40",
        "foreground__grey_2": "#4a4d50",
        "foreground__grey_3": "#5c6166",
        "foreground__grey_4": "#6f757b",
        "foreground__informative": "#085398",
        "foreground__primary": "#2d2f32",
        "foreground__warning": "#e4b91e",
        "interactive_content__badge__1": "#0099ff",
        "interactive_content__badge__2": "#00d066",
        "interactive_content__badge__3": "#380354",
        "interactive_content__badge__4": "#6e6e6e",
        "interactive_content__badge__5": "#990ae3",
        "interactive_content__badge__6": "#e4175c",
        "interactive_content__badge__7": "#ff9b00",
        "interactive_content__badge__outline": "#ffffff",
        "interactive_content__badge__text": "#ffffff",
        "interactive_content__buttons__black_to_white__fill_default": "#000000",
        "interactive_content__buttons__black_to_white__fill_hover": "#3d3e40",
        "interactive_content__buttons__black_to_white__fill_pressed": "#2d2f32",
        "interactive_content__buttons__black_to_white__outline_default": "#000000",
        "interactive_content__buttons__black_to_white__outline_hover": "#3d3e40",
        "interactive_content__buttons__black_to_white__outline_pressed": "#2d2f32",
        "interactive_content__buttons__black_to_white__text_default": "#f5f6f7",
        "interactive_content__buttons__black_to_white__text_hover": "#ffffff",
        "interactive_content__buttons__black_to_white__text_pressed": "#ffffff",
        "interactive_content__buttons__destructive__fill_default": "#fde5e6",
        "interactive_content__buttons__destructive__fill_hover": "#fde5e6",
        "interactive_content__buttons__destructive__fill_pressed": "#fbcbcd",
        "interactive_content__buttons__destructive__outline_default": "#fde5e6",
        "interactive_content__buttons__destructive__outline_hover": "#f46f74",
        "interactive_content__buttons__destructive__outline_pressed": "#fbcbcd",
        "interactive_content__buttons__destructive__text_default": "#c72127",
        "interactive_content__buttons__destructive__text_hover": "#c72127",
        "interactive_content__buttons__destructive__text_pressed": "#c72127",
        "interactive_content__buttons__ghost__fill_default": "#00000000",
        "interactive_content__buttons__ghost__fill_hover": "#d9dcdf",
        "interactive_content__buttons__ghost__fill_pressed": "#c3c8cd",
        "interactive_content__buttons__ghost__outline_default": "#00000000",
        "interactive_content__buttons__ghost__outline_hover": "#d9dcdf",
        "interactive_content__buttons__ghost__outline_pressed": "#c3c8cd",
        "interactive_content__buttons__ghost__text_default": "#2d2f32",
        "interactive_content__buttons__ghost__text_hover": "#000000",
        "interactive_content__buttons__ghost__text_pressed": "#2d2f32",
        "interactive_content__buttons__outline__fill_default": "#00000000",
        "interactive_content__buttons__outline__fill_hover": "#f5f6f7",
        "interactive_content__buttons__outline__fill_pressed": "#f5f6f7",
        "interactive_content__buttons__outline__outline_default": "#92989f",
        "interactive_content__buttons__outline__outline_hover": "#6f757b",
        "interactive_content__buttons__outline__outline_pressed": "#a7acb1",
        "interactive_content__buttons__outline__text_default": "#2d2f32",
        "interactive_content__buttons__outline__text_hover": "#000000",
        "interactive_content__buttons__outline__text_pressed": "#000000",
        "interactive_content__buttons__primary__fill_default": "#47096f",
        "interactive_content__buttons__primary__fill_hover": "#63119d",
        "interactive_content__buttons__primary__fill_pressed": "#801bc8",
        "interactive_content__buttons__primary__outline_default": "#47096f",
        "interactive_content__buttons__primary__outline_hover": "#63119d",
        "interactive_content__buttons__primary__outline_pressed": "#801bc8",
        "interactive_content__buttons__primary__text_default": "#ffffff",
        "interactive_content__buttons__primary__text_hover": "#ffffff",
        "interactive_content__buttons__primary__text_pressed": "#ffffff",
        "interactive_content__edit_mode__background": "#47096f",
        "interactive_content__edit_mode__foreground": "#ffffff",
        "interactive_content__lists__surface_on_hover": "#f1f2f2",
        "interactive_content__lists__surface_on_hover_branded": "#f1f2f2",
        "interactive_content__lists__surface_while_active": "#ebf2ff",
        "interactive_content__lists__surface_while_active_branded": "#ebf2ff",
        "interactive_content__text_link__default": "#085398",
        "interactive_content__tooltips__background": "#000000",
        "interactive_content__tooltips__foreground": "#ffffff",
        "interactive_content__tooltips__icon": "#f5f6f7",
        "unbranded_colors__blue": "#46a8ef",
        "unbranded_colors__green": "#329086",
        "unbranded_colors__purple": "#df57d9",
        "unbranded_colors__red": "#f46f74",
        "unbranded_colors__yellow": "#edd26f",
        "web__authentication__background": "#47096f",
        "web__authentication__header_foreground": "#ffffff",
        "web__header__background": "#ffffff00",
        "web__header__foreground": "#2d2f32",
        "web__navigation__background": "#f9fafa",
        "web__navigation__divider": "#d9dcdf",
        "web__navigation__foreground_default": "#6f757b",
        "web__navigation__foreground_hover": "#29003e",
        "web__navigation__foreground_pressed": "#29003e",
        "web__upgrade__background": "#f9fafa",
        "web__upgrade__recommended": "#2d2f32",
        "web__upgrade__tab_selection_line": "#2d2f32",
        "web__upgrade__tag": "#f5f6f7",
        "web__upgrade__text_highlight": "#2d2f32",
        "website__paid_signup_custom__background_left": "#ffffff",
        "website__paid_signup_custom__background_logo_icon": "#ffffff",
        "website__paid_signup_custom__background_right": "#f5f6f7",
        "website__paid_signup_custom__divider": "#d9dcdf",
        "website__paid_signup_custom__link": "#990ae3",
        "website__paid_signup_custom__password_box": "#f1f2f2",
        "website__paid_signup_custom__radio_button": "#0b76d9",
        "website__paid_signup_custom__radio_button_background": "#ebf2ff",
        "website__paid_signup_custom__radio_button_background_hover": "#f9fafa",
        "website__paid_signup_custom__radio_button_stroke_hover": "#0b76d9",
        "website__paid_signup_custom__strong_password": "#5eb2aa",
        "website__paid_signup_custom__subtext_summary": "#5c6166"
      }
    },
    "teliacloud": {
      "colors": {
        "background__critical_danger": "#ef3138",
        "background__critical_warning": "#e4b91e",
        "background__danger": "#fde5e6",
        "background__good": "#d4f7f0",
        "background__grey_1": "#f9fafa",
        "background__grey_2": "#f5f6f7",
        "background__grey_3": "#f1f2f2",
        "background__grey_4": "#ededed",
        "background__grey_5": "#e8e8e8",
        "background__grey_6": "#e3e3e3",
        "background__informative": "#ebf2ff",
        "background__primary": "#ffffff",
        "background__warning": "#faf4d9",
        "black_and_white__always_black": "#000000",
        "black_and_white__always_white": "#ffffff",
        "black_and_white__auto_black_to_white": "#000000",
        "black_and_white__auto_grey_to_black": "#f1f2f2",
        "black_and_white__auto_white_to_black": "#ffffff",
        "border__base": "#a7acb1",
        "border__in_focus": "#085398",
        "border__light_base": "#d9dcdf",
        "border__lightest_base": "#ededed",
        "elements__alert": "#47096f",
        "elements__context_menu": "#ffffff",
        "elements__control_element": "#0b76d9",
        "elements__divider": "#a7acb1",
        "elements__file_and_folder_icons__file_background": "#f1f2f2",
        "elements__file_and_folder_icons__file_foreground": "#2d2f32",
        "elements__file_and_folder_icons__folder_background": "#ffffff",
        "elements__file_and_folder_icons__folder_background_active": "#ebf2ff",
        "elements__folder_icons": "#47096f",
        "elements__logo": "#47096f",
        "elements__modal_branded": "#ffffff",
        "elements__modal_unbranded": "#ffffff",
        "email__heading": "#29003e",
        "foreground__danger": "#ef3138",
        "foreground__good": "#00685e",
        "foreground__grey_1": "#3d3e40",
        "foreground__grey_2": "#4a4d50",
        "foreground__grey_3": "#5c6166",
        "foreground__grey_4": "#6f757b",
        "foreground__informative": "#085398",
        "foreground__primary": "#2d2f32",
        "foreground__warning": "#e4b91e",
        "interactive_content__badge__1": "#0099ff",
        "interactive_content__badge__2": "#00d066",
        "interactive_content__badge__3": "#380354",
        "interactive_content__badge__4": "#6e6e6e",
        "interactive_content__badge__5": "#990ae3",
        "interactive_content__badge__6": "#e4175c",
        "interactive_content__badge__7": "#ff9b00",
        "interactive_content__badge__outline": "#ffffff",
        "interactive_content__badge__text": "#ffffff",
        "interactive_content__buttons__black_to_white__fill_default": "#000000",
        "interactive_content__buttons__black_to_white__fill_hover": "#3d3e40",
        "interactive_content__buttons__black_to_white__fill_pressed": "#2d2f32",
        "interactive_content__buttons__black_to_white__outline_default": "#000000",
        "interactive_content__buttons__black_to_white__outline_hover": "#3d3e40",
        "interactive_content__buttons__black_to_white__outline_pressed": "#2d2f32",
        "interactive_content__buttons__black_to_white__text_default": "#f5f6f7",
        "interactive_content__buttons__black_to_white__text_hover": "#ffffff",
        "interactive_content__buttons__black_to_white__text_pressed": "#ffffff",
        "interactive_content__buttons__destructive__fill_default": "#fde5e6",
        "interactive_content__buttons__destructive__fill_hover": "#fde5e6",
        "interactive_content__buttons__destructive__fill_pressed": "#fbcbcd",
        "interactive_content__buttons__destructive__outline_default": "#fde5e6",
        "interactive_content__buttons__destructive__outline_hover": "#f46f74",
        "interactive_content__buttons__destructive__outline_pressed": "#fbcbcd",
        "interactive_content__buttons__destructive__text_default": "#c72127",
        "interactive_content__buttons__destructive__text_hover": "#c72127",
        "interactive_content__buttons__destructive__text_pressed": "#c72127",
        "interactive_content__buttons__ghost__fill_default": "#00000000",
        "interactive_content__buttons__ghost__fill_hover": "#d9dcdf",
        "interactive_content__buttons__ghost__fill_pressed": "#c3c8cd",
        "interactive_content__buttons__ghost__outline_default": "#00000000",
        "interactive_content__buttons__ghost__outline_hover": "#d9dcdf",
        "interactive_content__buttons__ghost__outline_pressed": "#c3c8cd",
        "interactive_content__buttons__ghost__text_default": "#2d2f32",
        "interactive_content__buttons__ghost__text_hover": "#000000",
        "interactive_content__buttons__ghost__text_pressed": "#2d2f32",
        "interactive_content__buttons__outline__fill_default": "#00000000",
        "interactive_content__buttons__outline__fill_hover": "#f5f6f7",
        "interactive_content__buttons__outline__fill_pressed": "#f5f6f7",
        "interactive_content__buttons__outline__outline_default": "#92989f",
        "interactive_content__buttons__outline__outline_hover": "#6f757b",
        "interactive_content__buttons__outline__outline_pressed": "#a7acb1",
        "interactive_content__buttons__outline__text_default": "#2d2f32",
        "interactive_content__buttons__outline__text_hover": "#000000",
        "interactive_content__buttons__outline__text_pressed": "#000000",
        "interactive_content__buttons__primary__fill_default": "#47096f",
        "interactive_content__buttons__primary__fill_hover": "#63119d",
        "interactive_content__buttons__primary__fill_pressed": "#801bc8",
        "interactive_content__buttons__primary__outline_default": "#47096f",
        "interactive_content__buttons__primary__outline_hover": "#63119d",
        "interactive_content__buttons__primary__outline_pressed": "#801bc8",
        "interactive_content__buttons__primary__text_default": "#ffffff",
        "interactive_content__buttons__primary__text_hover": "#ffffff",
        "interactive_content__buttons__primary__text_pressed": "#ffffff",
        "interactive_content__edit_mode__background": "#47096f",
        "interactive_content__edit_mode__foreground": "#ffffff",
        "interactive_content__lists__surface_on_hover": "#f1f2f2",
        "interactive_content__lists__surface_on_hover_branded": "#f1f2f2",
        "interactive_content__lists__surface_while_active": "#ebf2ff",
        "interactive_content__lists__surface_while_active_branded": "#ebf2ff",
        "interactive_content__text_link__default": "#085398",
        "interactive_content__tooltips__background": "#000000",
        "interactive_content__tooltips__foreground": "#ffffff",
        "interactive_content__tooltips__icon": "#f5f6f7",
        "unbranded_colors__blue": "#46a8ef",
        "unbranded_colors__green": "#329086",
        "unbranded_colors__purple": "#df57d9",
        "unbranded_colors__red": "#f46f74",
        "unbranded_colors__yellow": "#edd26f",
        "web__authentication__background": "#47096f",
        "web__authentication__header_foreground": "#ffffff",
        "web__header__background": "#ffffff00",
        "web__header__foreground": "#2d2f32",
        "web__navigation__background": "#f9fafa",
        "web__navigation__divider": "#d9dcdf",
        "web__navigation__foreground_default": "#6f757b",
        "web__navigation__foreground_hover": "#29003e",
        "web__navigation__foreground_pressed": "#29003e",
        "web__upgrade__background": "#f9fafa",
        "web__upgrade__recommended": "#2d2f32",
        "web__upgrade__tab_selection_line": "#2d2f32",
        "web__upgrade__tag": "#f5f6f7",
        "web__upgrade__text_highlight": "#2d2f32",
        "website__paid_signup_custom__background_left": "#ffffff",
        "website__paid_signup_custom__background_logo_icon": "#ffffff",
        "website__paid_signup_custom__background_right": "#f5f6f7",
        "website__paid_signup_custom__divider": "#d9dcdf",
        "website__paid_signup_custom__link": "#990ae3",
        "website__paid_signup_custom__password_box": "#f1f2f2",
        "website__paid_signup_custom__radio_button": "#0b76d9",
        "website__paid_signup_custom__radio_button_background": "#ebf2ff",
        "website__paid_signup_custom__radio_button_background_hover": "#f9fafa",
        "website__paid_signup_custom__radio_button_stroke_hover": "#0b76d9",
        "website__paid_signup_custom__strong_password": "#5eb2aa",
        "website__paid_signup_custom__subtext_summary": "#5c6166"
      }
    },
    "tsky": {
      "colors": {
        "background__critical_danger": "#ef3138",
        "background__critical_warning": "#e4b91e",
        "background__danger": "#fde5e6",
        "background__good": "#d4f7f0",
        "background__grey_1": "#f9fafa",
        "background__grey_2": "#f5f6f7",
        "background__grey_3": "#f1f2f2",
        "background__grey_4": "#ededed",
        "background__grey_5": "#e8e8e8",
        "background__grey_6": "#e3e3e3",
        "background__informative": "#ebf2ff",
        "background__primary": "#ffffff",
        "background__warning": "#faf4d9",
        "black_and_white__always_black": "#000000",
        "black_and_white__always_white": "#ffffff",
        "black_and_white__auto_black_to_white": "#000000",
        "black_and_white__auto_grey_to_black": "#f1f2f2",
        "black_and_white__auto_white_to_black": "#ffffff",
        "border__base": "#a7acb1",
        "border__in_focus": "#085398",
        "border__light_base": "#d9dcdf",
        "border__lightest_base": "#ededed",
        "elements__alert": "#47096f",
        "elements__context_menu": "#ffffff",
        "elements__control_element": "#0b76d9",
        "elements__divider": "#a7acb1",
        "elements__file_and_folder_icons__file_background": "#f1f2f2",
        "elements__file_and_folder_icons__file_foreground": "#2d2f32",
        "elements__file_and_folder_icons__folder_background": "#ffffff",
        "elements__file_and_folder_icons__folder_background_active": "#ebf2ff",
        "elements__folder_icons": "#47096f",
        "elements__logo": "#47096f",
        "elements__modal_branded": "#ffffff",
        "elements__modal_unbranded": "#ffffff",
        "email__heading": "#29003e",
        "foreground__danger": "#ef3138",
        "foreground__good": "#00685e",
        "foreground__grey_1": "#3d3e40",
        "foreground__grey_2": "#4a4d50",
        "foreground__grey_3": "#5c6166",
        "foreground__grey_4": "#6f757b",
        "foreground__informative": "#085398",
        "foreground__primary": "#2d2f32",
        "foreground__warning": "#e4b91e",
        "interactive_content__badge__1": "#0099ff",
        "interactive_content__badge__2": "#00d066",
        "interactive_content__badge__3": "#380354",
        "interactive_content__badge__4": "#6e6e6e",
        "interactive_content__badge__5": "#990ae3",
        "interactive_content__badge__6": "#e4175c",
        "interactive_content__badge__7": "#ff9b00",
        "interactive_content__badge__outline": "#ffffff",
        "interactive_content__badge__text": "#ffffff",
        "interactive_content__buttons__black_to_white__fill_default": "#000000",
        "interactive_content__buttons__black_to_white__fill_hover": "#3d3e40",
        "interactive_content__buttons__black_to_white__fill_pressed": "#2d2f32",
        "interactive_content__buttons__black_to_white__outline_default": "#000000",
        "interactive_content__buttons__black_to_white__outline_hover": "#3d3e40",
        "interactive_content__buttons__black_to_white__outline_pressed": "#2d2f32",
        "interactive_content__buttons__black_to_white__text_default": "#f5f6f7",
        "interactive_content__buttons__black_to_white__text_hover": "#ffffff",
        "interactive_content__buttons__black_to_white__text_pressed": "#ffffff",
        "interactive_content__buttons__destructive__fill_default": "#fde5e6",
        "interactive_content__buttons__destructive__fill_hover": "#fde5e6",
        "interactive_content__buttons__destructive__fill_pressed": "#fbcbcd",
        "interactive_content__buttons__destructive__outline_default": "#fde5e6",
        "interactive_content__buttons__destructive__outline_hover": "#f46f74",
        "interactive_content__buttons__destructive__outline_pressed": "#fbcbcd",
        "interactive_content__buttons__destructive__text_default": "#c72127",
        "interactive_content__buttons__destructive__text_hover": "#c72127",
        "interactive_content__buttons__destructive__text_pressed": "#c72127",
        "interactive_content__buttons__ghost__fill_default": "#00000000",
        "interactive_content__buttons__ghost__fill_hover": "#d9dcdf",
        "interactive_content__buttons__ghost__fill_pressed": "#c3c8cd",
        "interactive_content__buttons__ghost__outline_default": "#00000000",
        "interactive_content__buttons__ghost__outline_hover": "#d9dcdf",
        "interactive_content__buttons__ghost__outline_pressed": "#c3c8cd",
        "interactive_content__buttons__ghost__text_default": "#2d2f32",
        "interactive_content__buttons__ghost__text_hover": "#000000",
        "interactive_content__buttons__ghost__text_pressed": "#2d2f32",
        "interactive_content__buttons__outline__fill_default": "#00000000",
        "interactive_content__buttons__outline__fill_hover": "#f5f6f7",
        "interactive_content__buttons__outline__fill_pressed": "#f5f6f7",
        "interactive_content__buttons__outline__outline_default": "#92989f",
        "interactive_content__buttons__outline__outline_hover": "#6f757b",
        "interactive_content__buttons__outline__outline_pressed": "#a7acb1",
        "interactive_content__buttons__outline__text_default": "#2d2f32",
        "interactive_content__buttons__outline__text_hover": "#000000",
        "interactive_content__buttons__outline__text_pressed": "#000000",
        "interactive_content__buttons__primary__fill_default": "#47096f",
        "interactive_content__buttons__primary__fill_hover": "#63119d",
        "interactive_content__buttons__primary__fill_pressed": "#801bc8",
        "interactive_content__buttons__primary__outline_default": "#47096f",
        "interactive_content__buttons__primary__outline_hover": "#63119d",
        "interactive_content__buttons__primary__outline_pressed": "#801bc8",
        "interactive_content__buttons__primary__text_default": "#ffffff",
        "interactive_content__buttons__primary__text_hover": "#ffffff",
        "interactive_content__buttons__primary__text_pressed": "#ffffff",
        "interactive_content__edit_mode__background": "#47096f",
        "interactive_content__edit_mode__foreground": "#ffffff",
        "interactive_content__lists__surface_on_hover": "#f1f2f2",
        "interactive_content__lists__surface_on_hover_branded": "#f1f2f2",
        "interactive_content__lists__surface_while_active": "#ebf2ff",
        "interactive_content__lists__surface_while_active_branded": "#ebf2ff",
        "interactive_content__text_link__default": "#085398",
        "interactive_content__tooltips__background": "#000000",
        "interactive_content__tooltips__foreground": "#ffffff",
        "interactive_content__tooltips__icon": "#f5f6f7",
        "unbranded_colors__blue": "#46a8ef",
        "unbranded_colors__green": "#329086",
        "unbranded_colors__purple": "#df57d9",
        "unbranded_colors__red": "#f46f74",
        "unbranded_colors__yellow": "#edd26f",
        "web__authentication__background": "#47096f",
        "web__authentication__header_foreground": "#ffffff",
        "web__header__background": "#ffffff00",
        "web__header__foreground": "#2d2f32",
        "web__navigation__background": "#f9fafa",
        "web__navigation__divider": "#d9dcdf",
        "web__navigation__foreground_default": "#6f757b",
        "web__navigation__foreground_hover": "#29003e",
        "web__navigation__foreground_pressed": "#29003e",
        "web__upgrade__background": "#f9fafa",
        "web__upgrade__recommended": "#2d2f32",
        "web__upgrade__tab_selection_line": "#2d2f32",
        "web__upgrade__tag": "#f5f6f7",
        "web__upgrade__text_highlight": "#2d2f32",
        "website__paid_signup_custom__background_left": "#ffffff",
        "website__paid_signup_custom__background_logo_icon": "#ffffff",
        "website__paid_signup_custom__background_right": "#f5f6f7",
        "website__paid_signup_custom__divider": "#d9dcdf",
        "website__paid_signup_custom__link": "#990ae3",
        "website__paid_signup_custom__password_box": "#f1f2f2",
        "website__paid_signup_custom__radio_button": "#0b76d9",
        "website__paid_signup_custom__radio_button_background": "#ebf2ff",
        "website__paid_signup_custom__radio_button_background_hover": "#f9fafa",
        "website__paid_signup_custom__radio_button_stroke_hover": "#0b76d9",
        "website__paid_signup_custom__strong_password": "#5eb2aa",
        "website__paid_signup_custom__subtext_summary": "#5c6166"
      }
    },
    "onlime": {
      "colors": {
        "background__critical_danger": "#ef3138",
        "background__critical_warning": "#e4b91e",
        "background__danger": "#fde5e6",
        "background__good": "#d4f7f0",
        "background__grey_1": "#f9fafa",
        "background__grey_2": "#f5f6f7",
        "background__grey_3": "#f1f2f2",
        "background__grey_4": "#ededed",
        "background__grey_5": "#e8e8e8",
        "background__grey_6": "#e3e3e3",
        "background__informative": "#ebf2ff",
        "background__primary": "#ffffff",
        "background__warning": "#faf4d9",
        "black_and_white__always_black": "#000000",
        "black_and_white__always_white": "#ffffff",
        "black_and_white__auto_black_to_white": "#000000",
        "black_and_white__auto_grey_to_black": "#f1f2f2",
        "black_and_white__auto_white_to_black": "#ffffff",
        "border__base": "#a7acb1",
        "border__in_focus": "#085398",
        "border__light_base": "#d9dcdf",
        "border__lightest_base": "#ededed",
        "elements__alert": "#73a604",
        "elements__context_menu": "#ffffff",
        "elements__control_element": "#0b76d9",
        "elements__divider": "#a7acb1",
        "elements__file_and_folder_icons__file_background": "#f1f2f2",
        "elements__file_and_folder_icons__file_foreground": "#2d2f32",
        "elements__file_and_folder_icons__folder_background": "#ffffff",
        "elements__file_and_folder_icons__folder_background_active": "#ebf2ff",
        "elements__folder_icons": "#73a604",
        "elements__logo": "#73a604",
        "elements__modal_branded": "#ffffff",
        "elements__modal_unbranded": "#ffffff",
        "email__heading": "#73a604",
        "foreground__danger": "#ef3138",
        "foreground__good": "#00685e",
        "foreground__grey_1": "#3d3e40",
        "foreground__grey_2": "#4a4d50",
        "foreground__grey_3": "#5c6166",
        "foreground__grey_4": "#6f757b",
        "foreground__informative": "#085398",
        "foreground__primary": "#2d2f32",
        "foreground__warning": "#e4b91e",
        "interactive_content__badge__1": "#4c543c",
        "interactive_content__badge__2": "#4c710d",
        "interactive_content__badge__3": "#7fb841",
        "interactive_content__badge__4": "#92b742",
        "interactive_content__badge__5": "#b7ca8f",
        "interactive_content__badge__6": "#4c710d",
        "interactive_content__badge__7": "#7fb841",
        "interactive_content__badge__outline": "#ffffff",
        "interactive_content__badge__text": "#ffffff",
        "interactive_content__buttons__black_to_white__fill_default": "#000000",
        "interactive_content__buttons__black_to_white__fill_hover": "#3d3e40",
        "interactive_content__buttons__black_to_white__fill_pressed": "#2d2f32",
        "interactive_content__buttons__black_to_white__outline_default": "#000000",
        "interactive_content__buttons__black_to_white__outline_hover": "#3d3e40",
        "interactive_content__buttons__black_to_white__outline_pressed": "#2d2f32",
        "interactive_content__buttons__black_to_white__text_default": "#f5f6f7",
        "interactive_content__buttons__black_to_white__text_hover": "#ffffff",
        "interactive_content__buttons__black_to_white__text_pressed": "#ffffff",
        "interactive_content__buttons__destructive__fill_default": "#fde5e6",
        "interactive_content__buttons__destructive__fill_hover": "#fde5e6",
        "interactive_content__buttons__destructive__fill_pressed": "#fbcbcd",
        "interactive_content__buttons__destructive__outline_default": "#fde5e6",
        "interactive_content__buttons__destructive__outline_hover": "#f46f74",
        "interactive_content__buttons__destructive__outline_pressed": "#fbcbcd",
        "interactive_content__buttons__destructive__text_default": "#c72127",
        "interactive_content__buttons__destructive__text_hover": "#c72127",
        "interactive_content__buttons__destructive__text_pressed": "#c72127",
        "interactive_content__buttons__ghost__fill_default": "#00000000",
        "interactive_content__buttons__ghost__fill_hover": "#d9dcdf",
        "interactive_content__buttons__ghost__fill_pressed": "#c3c8cd",
        "interactive_content__buttons__ghost__outline_default": "#00000000",
        "interactive_content__buttons__ghost__outline_hover": "#d9dcdf",
        "interactive_content__buttons__ghost__outline_pressed": "#c3c8cd",
        "interactive_content__buttons__ghost__text_default": "#2d2f32",
        "interactive_content__buttons__ghost__text_hover": "#000000",
        "interactive_content__buttons__ghost__text_pressed": "#2d2f32",
        "interactive_content__buttons__outline__fill_default": "#00000000",
        "interactive_content__buttons__outline__fill_hover": "#f5f6f7",
        "interactive_content__buttons__outline__fill_pressed": "#f5f6f7",
        "interactive_content__buttons__outline__outline_default": "#92989f",
        "interactive_content__buttons__outline__outline_hover": "#6f757b",
        "interactive_content__buttons__outline__outline_pressed": "#a7acb1",
        "interactive_content__buttons__outline__text_default": "#2d2f32",
        "interactive_content__buttons__outline__text_hover": "#000000",
        "interactive_content__buttons__outline__text_pressed": "#000000",
        "interactive_content__buttons__primary__fill_default": "#73a604",
        "interactive_content__buttons__primary__fill_hover": "#7db00e",
        "interactive_content__buttons__primary__fill_pressed": "#699c00",
        "interactive_content__buttons__primary__outline_default": "#73a604",
        "interactive_content__buttons__primary__outline_hover": "#7db00e",
        "interactive_content__buttons__primary__outline_pressed": "#699c00",
        "interactive_content__buttons__primary__text_default": "#ffffff",
        "interactive_content__buttons__primary__text_hover": "#ffffff",
        "interactive_content__buttons__primary__text_pressed": "#ffffff",
        "interactive_content__edit_mode__background": "#73a604",
        "interactive_content__edit_mode__foreground": "#ffffff",
        "interactive_content__lists__surface_on_hover": "#f1f2f2",
        "interactive_content__lists__surface_on_hover_branded": "#f1f2f2",
        "interactive_content__lists__surface_while_active": "#ebf2ff",
        "interactive_content__lists__surface_while_active_branded": "#ebf2ff",
        "interactive_content__text_link__default": "#085398",
        "interactive_content__tooltips__background": "#000000",
        "interactive_content__tooltips__foreground": "#ffffff",
        "interactive_content__tooltips__icon": "#f5f6f7",
        "unbranded_colors__blue": "#46a8ef",
        "unbranded_colors__green": "#329086",
        "unbranded_colors__purple": "#df57d9",
        "unbranded_colors__red": "#f46f74",
        "unbranded_colors__yellow": "#edd26f",
        "web__authentication__background": "#f9fafa",
        "web__authentication__header_foreground": "#2d2f32",
        "web__header__background": "#ffffff00",
        "web__header__foreground": "#2d2f32",
        "web__navigation__background": "#f9fafa",
        "web__navigation__divider": "#d9dcdf",
        "web__navigation__foreground_default": "#6f757b",
        "web__navigation__foreground_hover": "#73a604",
        "web__navigation__foreground_pressed": "#73a604",
        "web__upgrade__background": "#f9fafa",
        "web__upgrade__recommended": "#2d2f32",
        "web__upgrade__tab_selection_line": "#2d2f32",
        "web__upgrade__tag": "#f5f6f7",
        "web__upgrade__text_highlight": "#2d2f32",
        "website__paid_signup_custom__background_left": "#ffffff",
        "website__paid_signup_custom__background_logo_icon": "#ffffff",
        "website__paid_signup_custom__background_right": "#f5f6f7",
        "website__paid_signup_custom__divider": "#d9dcdf",
        "website__paid_signup_custom__link": "#73a604",
        "website__paid_signup_custom__password_box": "#f1f2f2",
        "website__paid_signup_custom__radio_button": "#0b76d9",
        "website__paid_signup_custom__radio_button_background": "#ebf2ff",
        "website__paid_signup_custom__radio_button_background_hover": "#0b76d9",
        "website__paid_signup_custom__radio_button_stroke_hover": "#0b76d9",
        "website__paid_signup_custom__strong_password": "#5eb2aa",
        "website__paid_signup_custom__subtext_summary": "#5c6166"
      }
    },
    "obos": {
      "colors": {
        "background__critical_danger": "#ef3138",
        "background__critical_warning": "#e4b91e",
        "background__danger": "#fde5e6",
        "background__good": "#d4f7f0",
        "background__grey_1": "#f9fafa",
        "background__grey_2": "#f5f6f7",
        "background__grey_3": "#f1f2f2",
        "background__grey_4": "#ededed",
        "background__grey_5": "#e8e8e8",
        "background__grey_6": "#e3e3e3",
        "background__informative": "#ebf2ff",
        "background__primary": "#ffffff",
        "background__warning": "#faf4d9",
        "black_and_white__always_black": "#000000",
        "black_and_white__always_white": "#ffffff",
        "black_and_white__auto_black_to_white": "#000000",
        "black_and_white__auto_grey_to_black": "#f1f2f2",
        "black_and_white__auto_white_to_black": "#ffffff",
        "border__base": "#a7acb1",
        "border__in_focus": "#085398",
        "border__light_base": "#d9dcdf",
        "border__lightest_base": "#ededed",
        "elements__alert": "#21514c",
        "elements__context_menu": "#ffffff",
        "elements__control_element": "#46a8ef",
        "elements__divider": "#a7acb1",
        "elements__file_and_folder_icons__file_background": "#f1f2f2",
        "elements__file_and_folder_icons__file_foreground": "#2d2f32",
        "elements__file_and_folder_icons__folder_background": "#ffffff",
        "elements__file_and_folder_icons__folder_background_active": "#ebf2ff",
        "elements__folder_icons": "#21514c",
        "elements__logo": "#092065",
        "elements__modal_branded": "#ffffff",
        "elements__modal_unbranded": "#ffffff",
        "email__heading": "#282f33",
        "foreground__danger": "#ef3138",
        "foreground__good": "#00685e",
        "foreground__grey_1": "#3d3e40",
        "foreground__grey_2": "#4a4d50",
        "foreground__grey_3": "#5c6166",
        "foreground__grey_4": "#6f757b",
        "foreground__informative": "#085398",
        "foreground__primary": "#2d2f32",
        "foreground__warning": "#e4b91e",
        "interactive_content__badge__1": "#cccccc",
        "interactive_content__badge__2": "#cccccc",
        "interactive_content__badge__3": "#cccccc",
        "interactive_content__badge__4": "#cccccc",
        "interactive_content__badge__5": "#cccccc",
        "interactive_content__badge__6": "#cccccc",
        "interactive_content__badge__7": "#cccccc",
        "interactive_content__badge__outline": "#cccccc",
        "interactive_content__badge__text": "#2d2f32",
        "interactive_content__buttons__black_to_white__fill_default": "#000000",
        "interactive_content__buttons__black_to_white__fill_hover": "#3d3e40",
        "interactive_content__buttons__black_to_white__fill_pressed": "#2d2f32",
        "interactive_content__buttons__black_to_white__outline_default": "#000000",
        "interactive_content__buttons__black_to_white__outline_hover": "#3d3e40",
        "interactive_content__buttons__black_to_white__outline_pressed": "#2d2f32",
        "interactive_content__buttons__black_to_white__text_default": "#f5f6f7",
        "interactive_content__buttons__black_to_white__text_hover": "#ffffff",
        "interactive_content__buttons__black_to_white__text_pressed": "#ffffff",
        "interactive_content__buttons__destructive__fill_default": "#fde5e6",
        "interactive_content__buttons__destructive__fill_hover": "#fde5e6",
        "interactive_content__buttons__destructive__fill_pressed": "#fbcbcd",
        "interactive_content__buttons__destructive__outline_default": "#fde5e6",
        "interactive_content__buttons__destructive__outline_hover": "#f46f74",
        "interactive_content__buttons__destructive__outline_pressed": "#fbcbcd",
        "interactive_content__buttons__destructive__text_default": "#c72127",
        "interactive_content__buttons__destructive__text_hover": "#c72127",
        "interactive_content__buttons__destructive__text_pressed": "#c72127",
        "interactive_content__buttons__ghost__fill_default": "#00000000",
        "interactive_content__buttons__ghost__fill_hover": "#d9dcdf",
        "interactive_content__buttons__ghost__fill_pressed": "#c3c8cd",
        "interactive_content__buttons__ghost__outline_default": "#00000000",
        "interactive_content__buttons__ghost__outline_hover": "#d9dcdf",
        "interactive_content__buttons__ghost__outline_pressed": "#c3c8cd",
        "interactive_content__buttons__ghost__text_default": "#2d2f32",
        "interactive_content__buttons__ghost__text_hover": "#000000",
        "interactive_content__buttons__ghost__text_pressed": "#2d2f32",
        "interactive_content__buttons__outline__fill_default": "#00000000",
        "interactive_content__buttons__outline__fill_hover": "#f5f6f7",
        "interactive_content__buttons__outline__fill_pressed": "#f5f6f7",
        "interactive_content__buttons__outline__outline_default": "#92989f",
        "interactive_content__buttons__outline__outline_hover": "#6f757b",
        "interactive_content__buttons__outline__outline_pressed": "#a7acb1",
        "interactive_content__buttons__outline__text_default": "#2d2f32",
        "interactive_content__buttons__outline__text_hover": "#000000",
        "interactive_content__buttons__outline__text_pressed": "#000000",
        "interactive_content__buttons__primary__fill_default": "#3b8564",
        "interactive_content__buttons__primary__fill_hover": "#317b5a",
        "interactive_content__buttons__primary__fill_pressed": "#277150",
        "interactive_content__buttons__primary__outline_default": "#3b8564",
        "interactive_content__buttons__primary__outline_hover": "#317b5a",
        "interactive_content__buttons__primary__outline_pressed": "#277150",
        "interactive_content__buttons__primary__text_default": "#ffffff",
        "interactive_content__buttons__primary__text_hover": "#ffffff",
        "interactive_content__buttons__primary__text_pressed": "#ffffff",
        "interactive_content__edit_mode__background": "#234ea1",
        "interactive_content__edit_mode__foreground": "#ffffff",
        "interactive_content__lists__surface_on_hover": "#ededed",
        "interactive_content__lists__surface_on_hover_branded": "#f1f2f2",
        "interactive_content__lists__surface_while_active": "#ebf2ff",
        "interactive_content__lists__surface_while_active_branded": "#ebf2ff",
        "interactive_content__text_link__default": "#085398",
        "interactive_content__tooltips__background": "#000000",
        "interactive_content__tooltips__foreground": "#ffffff",
        "interactive_content__tooltips__icon": "#f5f6f7",
        "unbranded_colors__blue": "#46a8ef",
        "unbranded_colors__green": "#329086",
        "unbranded_colors__purple": "#df57d9",
        "unbranded_colors__red": "#f46f74",
        "unbranded_colors__yellow": "#edd26f",
        "web__authentication__background": "#092065",
        "web__authentication__header_foreground": "#ffffff",
        "web__header__background": "#00000000",
        "web__header__foreground": "#2d2f32",
        "web__navigation__background": "#f9fafa",
        "web__navigation__divider": "#d9dcdf",
        "web__navigation__foreground_default": "#6f757b",
        "web__navigation__foreground_hover": "#092065",
        "web__navigation__foreground_pressed": "#092065",
        "web__upgrade__background": "#f9fafa",
        "web__upgrade__recommended": "#2d2f32",
        "web__upgrade__tab_selection_line": "#2d2f32",
        "web__upgrade__tag": "#f5f6f7",
        "web__upgrade__text_highlight": "#2d2f32",
        "website__paid_signup_custom__background_left": "#ffffff",
        "website__paid_signup_custom__background_logo_icon": "#ffffff",
        "website__paid_signup_custom__background_right": "#f5f6f7",
        "website__paid_signup_custom__divider": "#d9dcdf",
        "website__paid_signup_custom__link": "#085398",
        "website__paid_signup_custom__password_box": "#f1f2f2",
        "website__paid_signup_custom__radio_button": "#0b76d9",
        "website__paid_signup_custom__radio_button_background": "#ebf2ff",
        "website__paid_signup_custom__radio_button_background_hover": "#f9fafa",
        "website__paid_signup_custom__radio_button_stroke_hover": "#0b76d9",
        "website__paid_signup_custom__strong_password": "#5eb2aa",
        "website__paid_signup_custom__subtext_summary": "#5c6166"
      }
    },
    "halebop": {
      "colors": {
        "background__critical_danger": "#ef3138",
        "background__critical_warning": "#e4b91e",
        "background__danger": "#fde5e6",
        "background__good": "#d4f7f0",
        "background__grey_1": "#f9fafa",
        "background__grey_2": "#f5f6f7",
        "background__grey_3": "#f1f2f2",
        "background__grey_4": "#ededed",
        "background__grey_5": "#e8e8e8",
        "background__grey_6": "#e3e3e3",
        "background__informative": "#ebf2ff",
        "background__primary": "#ffffff",
        "background__warning": "#faf4d9",
        "black_and_white__always_black": "#000000",
        "black_and_white__always_white": "#ffffff",
        "black_and_white__auto_black_to_white": "#000000",
        "black_and_white__auto_grey_to_black": "#f1f2f2",
        "black_and_white__auto_white_to_black": "#ffffff",
        "border__base": "#a7acb1",
        "border__in_focus": "#085398",
        "border__light_base": "#d9dcdf",
        "border__lightest_base": "#ededed",
        "elements__alert": "#22a770",
        "elements__context_menu": "#ffffff",
        "elements__control_element": "#0b76d9",
        "elements__divider": "#a7acb1",
        "elements__file_and_folder_icons__file_background": "#f1f2f2",
        "elements__file_and_folder_icons__file_foreground": "#2d2f32",
        "elements__file_and_folder_icons__folder_background": "#ffffff",
        "elements__file_and_folder_icons__folder_background_active": "#ebf2ff",
        "elements__folder_icons": "#4a4d50",
        "elements__logo": "#9edcdc",
        "elements__modal_branded": "#ffffff",
        "elements__modal_unbranded": "#ffffff",
        "email__heading": "#282f33",
        "foreground__danger": "#ef3138",
        "foreground__good": "#00685e",
        "foreground__grey_1": "#3d3e40",
        "foreground__grey_2": "#4a4d50",
        "foreground__grey_3": "#5c6166",
        "foreground__grey_4": "#6f757b",
        "foreground__informative": "#085398",
        "foreground__primary": "#2d2f32",
        "foreground__warning": "#e4b91e",
        "interactive_content__badge__1": "#22a770",
        "interactive_content__badge__2": "#272a2e",
        "interactive_content__badge__3": "#5acc9e",
        "interactive_content__badge__4": "#91979b",
        "interactive_content__badge__5": "#fd5458",
        "interactive_content__badge__6": "#ff957c",
        "interactive_content__badge__7": "#91979b",
        "interactive_content__badge__outline": "#ffffff",
        "interactive_content__badge__text": "#ffffff",
        "interactive_content__buttons__black_to_white__fill_default": "#000000",
        "interactive_content__buttons__black_to_white__fill_hover": "#3d3e40",
        "interactive_content__buttons__black_to_white__fill_pressed": "#2d2f32",
        "interactive_content__buttons__black_to_white__outline_default": "#000000",
        "interactive_content__buttons__black_to_white__outline_hover": "#3d3e40",
        "interactive_content__buttons__black_to_white__outline_pressed": "#2d2f32",
        "interactive_content__buttons__black_to_white__text_default": "#f5f6f7",
        "interactive_content__buttons__black_to_white__text_hover": "#ffffff",
        "interactive_content__buttons__black_to_white__text_pressed": "#ffffff",
        "interactive_content__buttons__destructive__fill_default": "#fde5e6",
        "interactive_content__buttons__destructive__fill_hover": "#fde5e6",
        "interactive_content__buttons__destructive__fill_pressed": "#fbcbcd",
        "interactive_content__buttons__destructive__outline_default": "#fde5e6",
        "interactive_content__buttons__destructive__outline_hover": "#f46f74",
        "interactive_content__buttons__destructive__outline_pressed": "#fbcbcd",
        "interactive_content__buttons__destructive__text_default": "#c72127",
        "interactive_content__buttons__destructive__text_hover": "#c72127",
        "interactive_content__buttons__destructive__text_pressed": "#c72127",
        "interactive_content__buttons__ghost__fill_default": "#00000000",
        "interactive_content__buttons__ghost__fill_hover": "#d9dcdf",
        "interactive_content__buttons__ghost__fill_pressed": "#c3c8cd",
        "interactive_content__buttons__ghost__outline_default": "#00000000",
        "interactive_content__buttons__ghost__outline_hover": "#d9dcdf",
        "interactive_content__buttons__ghost__outline_pressed": "#c3c8cd",
        "interactive_content__buttons__ghost__text_default": "#2d2f32",
        "interactive_content__buttons__ghost__text_hover": "#000000",
        "interactive_content__buttons__ghost__text_pressed": "#2d2f32",
        "interactive_content__buttons__outline__fill_default": "#00000000",
        "interactive_content__buttons__outline__fill_hover": "#f5f6f7",
        "interactive_content__buttons__outline__fill_pressed": "#f5f6f7",
        "interactive_content__buttons__outline__outline_default": "#92989f",
        "interactive_content__buttons__outline__outline_hover": "#6f757b",
        "interactive_content__buttons__outline__outline_pressed": "#a7acb1",
        "interactive_content__buttons__outline__text_default": "#2d2f32",
        "interactive_content__buttons__outline__text_hover": "#000000",
        "interactive_content__buttons__outline__text_pressed": "#000000",
        "interactive_content__buttons__primary__fill_default": "#fbf048",
        "interactive_content__buttons__primary__fill_hover": "#fffa52",
        "interactive_content__buttons__primary__fill_pressed": "#f1e63e",
        "interactive_content__buttons__primary__outline_default": "#000000",
        "interactive_content__buttons__primary__outline_hover": "#000000",
        "interactive_content__buttons__primary__outline_pressed": "#000000",
        "interactive_content__buttons__primary__text_default": "#000000",
        "interactive_content__buttons__primary__text_hover": "#000000",
        "interactive_content__buttons__primary__text_pressed": "#000000",
        "interactive_content__edit_mode__background": "#22a770",
        "interactive_content__edit_mode__foreground": "#ffffff",
        "interactive_content__lists__surface_on_hover": "#f1f2f2",
        "interactive_content__lists__surface_on_hover_branded": "#f1f2f2",
        "interactive_content__lists__surface_while_active": "#ebf2ff",
        "interactive_content__lists__surface_while_active_branded": "#ebf2ff",
        "interactive_content__text_link__default": "#085398",
        "interactive_content__tooltips__background": "#000000",
        "interactive_content__tooltips__foreground": "#ffffff",
        "interactive_content__tooltips__icon": "#f5f6f7",
        "unbranded_colors__blue": "#46a8ef",
        "unbranded_colors__green": "#329086",
        "unbranded_colors__purple": "#df57d9",
        "unbranded_colors__red": "#f46f74",
        "unbranded_colors__yellow": "#edd26f",
        "web__authentication__background": "#9edcdc",
        "web__authentication__header_foreground": "#2d2f32",
        "web__header__background": "#9edcdc",
        "web__header__foreground": "#2d2f32",
        "web__navigation__background": "#f9fafa",
        "web__navigation__divider": "#d9dcdf",
        "web__navigation__foreground_default": "#6f757b",
        "web__navigation__foreground_hover": "#000000",
        "web__navigation__foreground_pressed": "#000000",
        "web__upgrade__background": "#f9fafa",
        "web__upgrade__recommended": "#2d2f32",
        "web__upgrade__tab_selection_line": "#2d2f32",
        "web__upgrade__tag": "#f5f6f7",
        "web__upgrade__text_highlight": "#2d2f32",
        "website__paid_signup_custom__background_left": "#ffffff",
        "website__paid_signup_custom__background_logo_icon": "#ffffff",
        "website__paid_signup_custom__background_right": "#f5f6f7",
        "website__paid_signup_custom__divider": "#d9dcdf",
        "website__paid_signup_custom__link": "#50c594",
        "website__paid_signup_custom__password_box": "#f1f2f2",
        "website__paid_signup_custom__radio_button": "#0b76d9",
        "website__paid_signup_custom__radio_button_background": "#ebf2ff",
        "website__paid_signup_custom__radio_button_background_hover": "#0b76d9",
        "website__paid_signup_custom__radio_button_stroke_hover": "#0b76d9",
        "website__paid_signup_custom__strong_password": "#5eb2aa",
        "website__paid_signup_custom__subtext_summary": "#5c6166"
      }
    },
    "phonero": {
      "colors": {
        "background__critical_danger": "#ef3138",
        "background__critical_warning": "#e4b91e",
        "background__danger": "#fde5e6",
        "background__good": "#d4f7f0",
        "background__grey_1": "#f9fafa",
        "background__grey_2": "#f5f6f7",
        "background__grey_3": "#f1f2f2",
        "background__grey_4": "#ededed",
        "background__grey_5": "#e8e8e8",
        "background__grey_6": "#e3e3e3",
        "background__informative": "#ebf2ff",
        "background__primary": "#ffffff",
        "background__warning": "#faf4d9",
        "black_and_white__always_black": "#000000",
        "black_and_white__always_white": "#ffffff",
        "black_and_white__auto_black_to_white": "#000000",
        "black_and_white__auto_grey_to_black": "#f1f2f2",
        "black_and_white__auto_white_to_black": "#ffffff",
        "border__base": "#a7acb1",
        "border__in_focus": "#085398",
        "border__light_base": "#d9dcdf",
        "border__lightest_base": "#ededed",
        "elements__alert": "#061a54",
        "elements__context_menu": "#ffffff",
        "elements__control_element": "#46a8ef",
        "elements__divider": "#a7acb1",
        "elements__file_and_folder_icons__file_background": "#f1f2f2",
        "elements__file_and_folder_icons__file_foreground": "#2d2f32",
        "elements__file_and_folder_icons__folder_background": "#ffffff",
        "elements__file_and_folder_icons__folder_background_active": "#ebf2ff",
        "elements__folder_icons": "#061a54",
        "elements__logo": "#cc081e",
        "elements__modal_branded": "#ffffff",
        "elements__modal_unbranded": "#ffffff",
        "email__heading": "#cc081e",
        "foreground__danger": "#ef3138",
        "foreground__good": "#00685e",
        "foreground__grey_1": "#3d3e40",
        "foreground__grey_2": "#4a4d50",
        "foreground__grey_3": "#5c6166",
        "foreground__grey_4": "#6f757b",
        "foreground__informative": "#085398",
        "foreground__primary": "#2d2f32",
        "foreground__warning": "#e4b91e",
        "interactive_content__badge__1": "#940011",
        "interactive_content__badge__2": "#ff4c60",
        "interactive_content__badge__3": "#000000",
        "interactive_content__badge__4": "#ad0417",
        "interactive_content__badge__5": "#ff4c60",
        "interactive_content__badge__6": "#940011",
        "interactive_content__badge__7": "#000000",
        "interactive_content__badge__outline": "#ffffff",
        "interactive_content__badge__text": "#ffffff",
        "interactive_content__buttons__black_to_white__fill_default": "#000000",
        "interactive_content__buttons__black_to_white__fill_hover": "#3d3e40",
        "interactive_content__buttons__black_to_white__fill_pressed": "#2d2f32",
        "interactive_content__buttons__black_to_white__outline_default": "#000000",
        "interactive_content__buttons__black_to_white__outline_hover": "#3d3e40",
        "interactive_content__buttons__black_to_white__outline_pressed": "#2d2f32",
        "interactive_content__buttons__black_to_white__text_default": "#f5f6f7",
        "interactive_content__buttons__black_to_white__text_hover": "#ffffff",
        "interactive_content__buttons__black_to_white__text_pressed": "#ffffff",
        "interactive_content__buttons__destructive__fill_default": "#fde5e6",
        "interactive_content__buttons__destructive__fill_hover": "#fde5e6",
        "interactive_content__buttons__destructive__fill_pressed": "#fbcbcd",
        "interactive_content__buttons__destructive__outline_default": "#fde5e6",
        "interactive_content__buttons__destructive__outline_hover": "#f46f74",
        "interactive_content__buttons__destructive__outline_pressed": "#fbcbcd",
        "interactive_content__buttons__destructive__text_default": "#c72127",
        "interactive_content__buttons__destructive__text_hover": "#c72127",
        "interactive_content__buttons__destructive__text_pressed": "#c72127",
        "interactive_content__buttons__ghost__fill_default": "#00000000",
        "interactive_content__buttons__ghost__fill_hover": "#d9dcdf",
        "interactive_content__buttons__ghost__fill_pressed": "#c3c8cd",
        "interactive_content__buttons__ghost__outline_default": "#00000000",
        "interactive_content__buttons__ghost__outline_hover": "#d9dcdf",
        "interactive_content__buttons__ghost__outline_pressed": "#c3c8cd",
        "interactive_content__buttons__ghost__text_default": "#2d2f32",
        "interactive_content__buttons__ghost__text_hover": "#000000",
        "interactive_content__buttons__ghost__text_pressed": "#2d2f32",
        "interactive_content__buttons__outline__fill_default": "#00000000",
        "interactive_content__buttons__outline__fill_hover": "#f5f6f7",
        "interactive_content__buttons__outline__fill_pressed": "#f5f6f7",
        "interactive_content__buttons__outline__outline_default": "#92989f",
        "interactive_content__buttons__outline__outline_hover": "#6f757b",
        "interactive_content__buttons__outline__outline_pressed": "#a7acb1",
        "interactive_content__buttons__outline__text_default": "#2d2f32",
        "interactive_content__buttons__outline__text_hover": "#000000",
        "interactive_content__buttons__outline__text_pressed": "#000000",
        "interactive_content__buttons__primary__fill_default": "#cc081e",
        "interactive_content__buttons__primary__fill_hover": "#c20014",
        "interactive_content__buttons__primary__fill_pressed": "#b8000a",
        "interactive_content__buttons__primary__outline_default": "#cc081e",
        "interactive_content__buttons__primary__outline_hover": "#c20014",
        "interactive_content__buttons__primary__outline_pressed": "#b8000a",
        "interactive_content__buttons__primary__text_default": "#ffffff",
        "interactive_content__buttons__primary__text_hover": "#ffffff",
        "interactive_content__buttons__primary__text_pressed": "#ffffff",
        "interactive_content__edit_mode__background": "#2d2f32",
        "interactive_content__edit_mode__foreground": "#ffffff",
        "interactive_content__lists__surface_on_hover": "#ededed",
        "interactive_content__lists__surface_on_hover_branded": "#f1f2f2",
        "interactive_content__lists__surface_while_active": "#ebf2ff",
        "interactive_content__lists__surface_while_active_branded": "#ebf2ff",
        "interactive_content__text_link__default": "#085398",
        "interactive_content__tooltips__background": "#000000",
        "interactive_content__tooltips__foreground": "#ffffff",
        "interactive_content__tooltips__icon": "#f5f6f7",
        "unbranded_colors__blue": "#46a8ef",
        "unbranded_colors__green": "#329086",
        "unbranded_colors__purple": "#df57d9",
        "unbranded_colors__red": "#f46f74",
        "unbranded_colors__yellow": "#edd26f",
        "web__authentication__background": "#060c27",
        "web__authentication__header_foreground": "#ffffff",
        "web__header__background": "#00000000",
        "web__header__foreground": "#2d2f32",
        "web__navigation__background": "#f9fafa",
        "web__navigation__divider": "#d9dcdf",
        "web__navigation__foreground_default": "#6f757b",
        "web__navigation__foreground_hover": "#cc081e",
        "web__navigation__foreground_pressed": "#cc081e",
        "web__upgrade__background": "#f9fafa",
        "web__upgrade__recommended": "#2d2f32",
        "web__upgrade__tab_selection_line": "#2d2f32",
        "web__upgrade__tag": "#f5f6f7",
        "web__upgrade__text_highlight": "#2d2f32",
        "website__paid_signup_custom__background_left": "#ffffff",
        "website__paid_signup_custom__background_logo_icon": "#ffffff",
        "website__paid_signup_custom__background_right": "#f5f6f7",
        "website__paid_signup_custom__divider": "#d9dcdf",
        "website__paid_signup_custom__link": "#085398",
        "website__paid_signup_custom__password_box": "#f1f2f2",
        "website__paid_signup_custom__radio_button": "#0b76d9",
        "website__paid_signup_custom__radio_button_background": "#ebf2ff",
        "website__paid_signup_custom__radio_button_background_hover": "#f9fafa",
        "website__paid_signup_custom__radio_button_stroke_hover": "#0b76d9",
        "website__paid_signup_custom__strong_password": "#5eb2aa",
        "website__paid_signup_custom__subtext_summary": "#5c6166"
      }
    },
    "letsgo": {
      "colors": {
        "background__critical_danger": "#ef3138",
        "background__critical_warning": "#e4b91e",
        "background__danger": "#fde5e6",
        "background__good": "#d4f7f0",
        "background__grey_1": "#f9fafa",
        "background__grey_2": "#f5f6f7",
        "background__grey_3": "#f1f2f2",
        "background__grey_4": "#ededed",
        "background__grey_5": "#e8e8e8",
        "background__grey_6": "#e3e3e3",
        "background__informative": "#ebf2ff",
        "background__primary": "#ffffff",
        "background__warning": "#faf4d9",
        "black_and_white__always_black": "#000000",
        "black_and_white__always_white": "#ffffff",
        "black_and_white__auto_black_to_white": "#000000",
        "black_and_white__auto_grey_to_black": "#f1f2f2",
        "black_and_white__auto_white_to_black": "#ffffff",
        "border__base": "#a7acb1",
        "border__in_focus": "#085398",
        "border__light_base": "#d9dcdf",
        "border__lightest_base": "#ededed",
        "elements__alert": "#df0000",
        "elements__context_menu": "#ffffff",
        "elements__control_element": "#46a8ef",
        "elements__divider": "#a7acb1",
        "elements__file_and_folder_icons__file_background": "#f1f2f2",
        "elements__file_and_folder_icons__file_foreground": "#2d2f32",
        "elements__file_and_folder_icons__folder_background": "#ffffff",
        "elements__file_and_folder_icons__folder_background_active": "#ebf2ff",
        "elements__folder_icons": "#272422",
        "elements__logo": "#df0000",
        "elements__modal_branded": "#ffffff",
        "elements__modal_unbranded": "#ffffff",
        "email__heading": "#282f33",
        "foreground__danger": "#ef3138",
        "foreground__good": "#00685e",
        "foreground__grey_1": "#3d3e40",
        "foreground__grey_2": "#4a4d50",
        "foreground__grey_3": "#5c6166",
        "foreground__grey_4": "#6f757b",
        "foreground__informative": "#085398",
        "foreground__primary": "#2d2f32",
        "foreground__warning": "#e4b91e",
        "interactive_content__badge__1": "#ff4848",
        "interactive_content__badge__2": "#d6a2a2",
        "interactive_content__badge__3": "#972727",
        "interactive_content__badge__4": "#bc5b5b",
        "interactive_content__badge__5": "#642020",
        "interactive_content__badge__6": "#df0000",
        "interactive_content__badge__7": "#121212",
        "interactive_content__badge__outline": "#ffffff",
        "interactive_content__badge__text": "#ffffff",
        "interactive_content__buttons__black_to_white__fill_default": "#000000",
        "interactive_content__buttons__black_to_white__fill_hover": "#3d3e40",
        "interactive_content__buttons__black_to_white__fill_pressed": "#2d2f32",
        "interactive_content__buttons__black_to_white__outline_default": "#000000",
        "interactive_content__buttons__black_to_white__outline_hover": "#3d3e40",
        "interactive_content__buttons__black_to_white__outline_pressed": "#2d2f32",
        "interactive_content__buttons__black_to_white__text_default": "#f5f6f7",
        "interactive_content__buttons__black_to_white__text_hover": "#ffffff",
        "interactive_content__buttons__black_to_white__text_pressed": "#ffffff",
        "interactive_content__buttons__destructive__fill_default": "#fde5e6",
        "interactive_content__buttons__destructive__fill_hover": "#fde5e6",
        "interactive_content__buttons__destructive__fill_pressed": "#fbcbcd",
        "interactive_content__buttons__destructive__outline_default": "#fde5e6",
        "interactive_content__buttons__destructive__outline_hover": "#f46f74",
        "interactive_content__buttons__destructive__outline_pressed": "#fbcbcd",
        "interactive_content__buttons__destructive__text_default": "#c72127",
        "interactive_content__buttons__destructive__text_hover": "#c72127",
        "interactive_content__buttons__destructive__text_pressed": "#c72127",
        "interactive_content__buttons__ghost__fill_default": "#00000000",
        "interactive_content__buttons__ghost__fill_hover": "#d9dcdf",
        "interactive_content__buttons__ghost__fill_pressed": "#c3c8cd",
        "interactive_content__buttons__ghost__outline_default": "#00000000",
        "interactive_content__buttons__ghost__outline_hover": "#d9dcdf",
        "interactive_content__buttons__ghost__outline_pressed": "#c3c8cd",
        "interactive_content__buttons__ghost__text_default": "#2d2f32",
        "interactive_content__buttons__ghost__text_hover": "#000000",
        "interactive_content__buttons__ghost__text_pressed": "#2d2f32",
        "interactive_content__buttons__outline__fill_default": "#00000000",
        "interactive_content__buttons__outline__fill_hover": "#f5f6f7",
        "interactive_content__buttons__outline__fill_pressed": "#f5f6f7",
        "interactive_content__buttons__outline__outline_default": "#92989f",
        "interactive_content__buttons__outline__outline_hover": "#6f757b",
        "interactive_content__buttons__outline__outline_pressed": "#a7acb1",
        "interactive_content__buttons__outline__text_default": "#2d2f32",
        "interactive_content__buttons__outline__text_hover": "#000000",
        "interactive_content__buttons__outline__text_pressed": "#000000",
        "interactive_content__buttons__primary__fill_default": "#000000",
        "interactive_content__buttons__primary__fill_hover": "#000000",
        "interactive_content__buttons__primary__fill_pressed": "#000000",
        "interactive_content__buttons__primary__outline_default": "#000000",
        "interactive_content__buttons__primary__outline_hover": "#000000",
        "interactive_content__buttons__primary__outline_pressed": "#000000",
        "interactive_content__buttons__primary__text_default": "#ffffff",
        "interactive_content__buttons__primary__text_hover": "#ffffff",
        "interactive_content__buttons__primary__text_pressed": "#ffffff",
        "interactive_content__edit_mode__background": "#2d2f32",
        "interactive_content__edit_mode__foreground": "#ffffff",
        "interactive_content__lists__surface_on_hover": "#ededed",
        "interactive_content__lists__surface_on_hover_branded": "#f1f2f2",
        "interactive_content__lists__surface_while_active": "#ebf2ff",
        "interactive_content__lists__surface_while_active_branded": "#ebf2ff",
        "interactive_content__text_link__default": "#085398",
        "interactive_content__tooltips__background": "#000000",
        "interactive_content__tooltips__foreground": "#ffffff",
        "interactive_content__tooltips__icon": "#f5f6f7",
        "unbranded_colors__blue": "#46a8ef",
        "unbranded_colors__green": "#329086",
        "unbranded_colors__purple": "#df57d9",
        "unbranded_colors__red": "#f46f74",
        "unbranded_colors__yellow": "#edd26f",
        "web__authentication__background": "#f3ebeb",
        "web__authentication__header_foreground": "#2d2f32",
        "web__header__background": "#00000000",
        "web__header__foreground": "#2d2f32",
        "web__navigation__background": "#f9fafa",
        "web__navigation__divider": "#d9dcdf",
        "web__navigation__foreground_default": "#6f757b",
        "web__navigation__foreground_hover": "#000000",
        "web__navigation__foreground_pressed": "#000000",
        "web__upgrade__background": "#f9fafa",
        "web__upgrade__recommended": "#2d2f32",
        "web__upgrade__tab_selection_line": "#2d2f32",
        "web__upgrade__tag": "#f5f6f7",
        "web__upgrade__text_highlight": "#2d2f32",
        "website__paid_signup_custom__background_left": "#ffffff",
        "website__paid_signup_custom__background_logo_icon": "#ffffff",
        "website__paid_signup_custom__background_right": "#f5f6f7",
        "website__paid_signup_custom__divider": "#d9dcdf",
        "website__paid_signup_custom__link": "#085398",
        "website__paid_signup_custom__password_box": "#f1f2f2",
        "website__paid_signup_custom__radio_button": "#0b76d9",
        "website__paid_signup_custom__radio_button_background": "#ebf2ff",
        "website__paid_signup_custom__radio_button_background_hover": "#f9fafa",
        "website__paid_signup_custom__radio_button_stroke_hover": "#0b76d9",
        "website__paid_signup_custom__strong_password": "#5eb2aa",
        "website__paid_signup_custom__subtext_summary": "#5c6166"
      }
    }
  }
}